<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light m-0">
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <v-snackbar
      v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :location="snackbar.position === 'top' ? 'top' : 'bottom'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3 ml-2" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
    <!-- popups  -->
    <v-row justify="center">
      <v-dialog v-model="selctedItemsPopup" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card class="v-card-100 m-0">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Selected {{ selected_table_data.length }} Items</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-card-actions>
              <v-btn class="text-blue bg-white text-none"  size="small" @click="assignExecutiveFnc">Assign Executive</v-btn>
              <v-btn class="text-blue bg-white text-none" color="white" size="small" @click="pickupaddMoreItems">Add More Items</v-btn>
              <v-btn class="text-red bg-white text-none" color="white" size="small" @click="deleteRequestpickup">Delete All</v-btn>
              <v-btn variant="solo" icon  dark @click="selctedItemsPopup = false"><v-icon color="white">mdi-close</v-icon></v-btn>
            </v-card-actions>
          </v-toolbar>
          <v-layout row>
            <v-data-table 
                    hover 
                    density="compact" 
                    :search="search" 
                     show-select 
                    v-model="selected" 
                    :headers="selected_headers"
                    :items="pagedData" 
                    :loading="loading" 
                    loading-text="Loading Data... Please wait"
                    class="elevation-1 dynamic-height" fixed-header 
                    height="100%"
                   return-object
                  >
                  <template #[`item.action`]="{ item }">
                    <img @click="deleteEvent(item)" src="@/assets/images/delete_red.png" title="Delete item" />
                  </template>
                  <template #[`item.sub_location`]="{ item }">
                    <span>{{ item.sub_location ? item.sub_location : "-" }}</span>
                  </template>
                  <template #[`item.lot_name`]="{ item }">
                    <span>{{ item.lot_name ? item.lot_name : "-" }}</span>
                  </template>
                </v-data-table>
             </v-layout>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="createPendingpackaging" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card class="v-card-100 m-0">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Selected {{ selected_table_data.length }} Items</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-card-actions>
              <v-btn class="text-blue bg-white text-none" variant="outlined" color="primary" @click="assignExecutiveFnc_2">Assign Executive</v-btn>
              <v-btn class="ml-2 text-blue bg-white text-none"  variant="outlined" color="primary" @click="packagingaddMoreItems">Add More Items</v-btn>
              <v-btn class="ml-2 text-red bg-white text-none"  variant="outlined" color="primary" @click="deleteRequest">Delete All</v-btn>
              <v-btn icon variant="solo" dark @click="createPendingpackaging = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-actions>
          </v-toolbar>
          <v-layout row>
                <v-data-table 
                   hover 
                   density="compact" 
                   show-select 
                   :search="search" 
                   v-model="selected" 
                   :headers="selected_headers"
                   :items="selected_table_data" 
                   :loading="loading" 
                   return-object 
                   loading-text="Loading Data... Please wait"
                   class="elevation-1 dynamic-height">
                  <template #[`item.action`]="{ item }">
                    <img @click="deleteEvent(item)" src="@/assets/images/delete_red.png" title="Delete item" />
                  </template>
                  <template #[`item.sub_location`]="{ item }">
                    <span>{{ item.sub_location ? item.sub_location : "-" }}</span>
                  </template>
                  <template #[`item.lot_name`]="{ item }">
                    <span>{{ item.lot_name ? item.lot_name : "-" }}</span>
                  </template>
                </v-data-table>
              </v-layout>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="assignExecutivePopup" persistent max-width="367px" style="height: 400px;">
        <v-card class="v-card-100 mt-0">
          <v-card-title class="d-flex align-center text-none">
            <span>Create Request</span><br>
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="assignExecutivePopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text>
            <v-container>
              <v-row style="justify-content: center;" class="margin-right">
                <v-autocomplete v-model="requestReason" disabled variant="outlined" :items="request_type = 'Packaging'"
                  item-title="name" item-value="id" label="Request Reason" style="max-width: 300px;"></v-autocomplete> <br>
              </v-row>
              <v-row>
                  <v-autocomplete v-model="assignTo" prepend-inner-icon="mdi-magnify"  variant="outlined" :items="assignee_ids" item-title="username" item-value="id"
                  label="Assign To" style="max-width: 300px;" multiple chips ref="brandAutocomplete"></v-autocomplete>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="margin-10" style="justify-content: center;">
            <!-- <v-spacer></v-spacer> -->
            <v-btn size="small" variant="outlined" color="primary" class="btn-cancel text-none mr-2 mb-3" @click="assignExecutivePopup = false">Cancel</v-btn>
            <v-btn size="small" color="primary" variant="flat" class="mb-3 text-none" @click="assignExecutiveSubmit" :disabled="!assignTo || number > 0">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="assignExecutivePopup_2" persistent max-width="367px" style="height: 400px;">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Create Request</span><br>
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="assignExecutivePopup_2 = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
        <v-divider :thickness="4" class="m-0" />
          <v-card-text>
            <v-container>
              <v-row style="justify-content: center;" class="margin-right">
                <v-autocomplete color="primary" v-model="assignTo" variant="outlined" :items="assignee_ids" item-title="username" item-value="id"
                  label="Assign To" style="max-width: 300px;" multiple chips ref="brandAutocomplete"></v-autocomplete>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="margin-10" style="justify-content: center;">
            <!-- <v-spacer></v-spacer> -->
            <v-btn size="small" variant="outlined" color="primary" class="btn-cancel text-none mr-2 mb-3" @click="assignExecutivePopup_2 = false">Cancel</v-btn>
            <v-btn size="small" variant="flat" color="primary" class="mb-3 text-none" @click="assignExecutiveSubmit_2" :disabled="!assignTo || number > 0">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>


    <!-- Edit request popup in request tracker -->
    <v-row justify="center">
      <v-dialog v-model="editRequestPopup" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-toolbar dark color="primary">
          <v-toolbar-title class="alert-link">Edit Request {{ req_id }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-card-actions>
            <v-btn class="text-blue text-none"  color="white" variant="flat" @click="editrequestSave" :disabled="number > 0"> Save & Update</v-btn>
            <v-btn icon variant="solo" dark @click="editRequestPopup = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-actions>
        </v-toolbar>
        <v-card class="v-card-100 m-0">
          <v-toolbar>
            <v-spacer></v-spacer>
            <v-card-actions>
              <v-btn class="text-blue text-none" color="primary" variant="outlined" @click="addMoreItemsReqTrack">Add More Items</v-btn>
              <v-btn class="text-blue text-none" color="primary" variant="outlined" @click="changeAssignmentEditFunc">Change Assignment</v-btn>
              <v-btn class="text-red text-none"  color="red" variant="outlined" @click="deleteReqTracker()">Delete Request</v-btn>
            </v-card-actions>
          </v-toolbar>
          <v-layout row>
                <v-data-table hover density="compact" :search="search" v-model="selected" show-select :headers="edit_req_headers"
                  :items="edit_req_table_data" :loading="loading" loading-text="Loading Data... Please wait"
                  class="elevation-1 dynamic-height" return-object>
                  <template #[`item.action`]="{ item }">
                    <img @click="deleteEvenTrack(item)" src="@/assets/images/delete_red.png" title="Delete item" />
                  </template>
                  <template #[`item.sub_location`]="{ item }">
                    <span>{{ item.sub_location ? item.sub_location : "-" }}</span>
                  </template>
                </v-data-table>
           </v-layout>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- change assignment popup request tracker -->
    <v-row justify="center">
      <v-dialog v-model="changeAssignmentPopup" persistent max-width="450px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Change Assignee</span><br>
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="changeAssignmentPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text>
            <v-container>
              <v-row style="justify-content: center;" class="margin-right">
                <v-autocomplete color="primary" v-model="change_assignment" variant="outlined" :items="change_assignment_items" item-title="username"
                  item-value="id" prepend-inner-icon="mdi-magnify"  label="Choose the Executive" style="max-width: 300px;" multiple chips
                  ref="brandAutocomplete"></v-autocomplete>
                <u><a href="#" class="select-all-link" @click="selectAll">Select All</a></u>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn variant="outlined" size="small" color="primary" class="btn-cancel  text-none mr-2 mb-3" @click="changeAssignmentPopup = false">Cancel</v-btn>
            <v-btn variant="flat" size="small" color="primary" class="mb-3 text-none" @click="changeAssignConfirm" :disabled="!change_assignment.length > 0 || number > 0 || !change_assignment">Confirm</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- add more items popup in request tracker -->
    <v-row justify="center">
      <v-dialog v-model="addMoreItemsPopup" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-toolbar dark color="primary">
          <v-toolbar-title class="alert-link">Selected Items {{ this.selected_add.length }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-card-actions>
            <v-btn class="text-blue text-none" color="white" small @click="addButton"
              :disabled="this.selected_add.length == 0">Add</v-btn>
            <v-btn icon variant="solo" dark @click="addMoreItemsPopup = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-actions>
        </v-toolbar>
        <v-card class="v-card-100 m-0">
          <v-toolbar class="tool_search">
            <v-text-field color="primary" prepend-inner-icon="mdi-magnify" v-model="add_item_search" label="Search"
              style="max-width: 300px; margin-top: 28px;padding:10px;" variant="outlined"
              v-on:keyup.enter="addMoreItemsReqTrack()"></v-text-field>
          </v-toolbar>
          <v-layout row>
            <v-data-table hover density="compact" :search="search" v-model="selected_add" show-select
              :headers="add_items_headers" :items="add_items_table_data" :loading="loading"
              loading-text="Loading Data... Please wait" class="elevation-1 dynamic-height" return-object>
              <template #[`item.sub_location`]="{ item }">
                <span>{{ item.sub_location ? item.sub_location : "-" }}</span>
              </template>
            </v-data-table>
            </v-layout>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- change assignment popup in edit assignment in Request-tracker tab -->
    <v-row justify="center">
      <v-dialog v-model="changeAssignmentEditPopup" persistent max-width="450px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Change Assignment</span><br>
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="changeAssignmentEditPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text>
            <v-container>
              <v-row style="justify-content: center;" class="margin-right">
                <v-autocomplete v-model="change_assignment_item_edit" variant="outlined" :items="change_assignment_edit_items"
                  item-title="username" item-value="id" label="Choose the Executive" style="max-width: 300px;" multiple
                  chips clearable ref="brandAutocomplete"></v-autocomplete>
                <u><a href="#" class="select-all-link" @click="selectAllEditItem">Select All</a></u>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn variant="outlined" color="primary" class="btn-cancel text-none mr-2 mb-3" @click="changeAssignmentEditPopup = false">Cancel</v-btn>
            <v-btn variant="flat" color="primary" class="mb-3 text-none" @click="changeAssignmentEditPopup = false" :disabled="!(change_assignment_item_edit && change_assignment_item_edit.length > 0)">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Cancel Request Pop up in Request-Tracker Tab -->
    <v-row justify="center">
      <v-dialog v-model="cancelRequestPopup" persistent max-width="470px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="cancelRequestPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-spacer></v-spacer>
          <v-card-text style="margin-top: 8px;text-align: center;">
            <span>Are you sure you want to cancel <span v-if="selected.length == 1">request</span> <span
                v-if="selected.length > 1">requests</span>
              <span v-for="item in selected" :key="item" style="font-weight: bold;"> {{ item.request_id }} </span>
              ?</span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="outlined" color="primary" class="btn-cancel text-none mr-2 mb-3" size="small"
              @click="cancelRequestPopup = false">Cancel</v-btn>
            <v-btn color="primary" variant="flat" class="mb-3 mr-5 text-none" size="small" @click="cancelRequestSubmit">Yes</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Update sublocation popup -->
    <v-row justify="center">
      <v-dialog v-model="updateSubLocation" persistent max-width="450px">
        <v-card class="v-card-100">
            <v-card-title class="d-flex align-center text-none">
              <span>Update Sub-Location</span><br>
              <v-spacer></v-spacer>
              <v-btn icon variant="solo" @click="updateSubLocation = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          <v-divider :thickness="2" class="border-opacity-50 m-0"/>
          <v-card-text>
            <v-container>
              <v-row style="justify-content: center;" class="mt-4">
                <v-autocomplete color="primary" v-model="sub_location" variant="outlined" :items="update_sub_location" item-title="code"
                  item-value="id" label="Enter The Sub-location" style="max-width: 300px;"></v-autocomplete>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="flat" class="mb-3 text-none" :disabled="number > 0" @click="updateSubLocSubmit">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Raise debit note popup in write off items in Not-found-items tab -->
    <v-row justify="center">
      <v-dialog v-model="raiseDebitNotePopup" persistent :max-width="$isRelianceClient() ? '424px' : '700px'">
        <v-card class="v-card-100">
            <v-card-title class="d-flex align-center">
              <span>Write Off Items</span>
              <v-spacer></v-spacer>
              <v-btn icon variant="solo" @click="raiseDebitNotePopup = raiseDebitNoteClose()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          <v-divider :thickness="2" class="border-opacity-50 m-0"/>
          <v-form>
            <v-card-text class="text-center" v-if="$isRelianceClient()">
                <span>Do you want to write off?</span>
             </v-card-text>
            <v-card-text v-else>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="4" md="6">
                    <v-text-field color="primary" hide-details label="Raise Note Against" variant="outlined" v-model="raise_note_against" type="text" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="6">
                    <v-text-field color="primary" label="Debit Amount" variant="outlined" v-model="debit_amount" :min="0" oninput="validity.valid||(value='');" type="number" required></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-form>
          <v-card-actions center  v-if="$isRelianceClient()">
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mb-3 text-none" variant="outlined" @click="raiseDebitNoteSubmit">Yes</v-btn>
              <v-btn color="primary" class="mb-3 text-none" variant="flat" @click="raiseDebitNotePopup = false">No</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          <v-card-actions center v-else>
            <v-spacer></v-spacer>
            <v-btn variant="outlined" color="primary" class="btn-cancel text-none mb-3" size="small" @click="raiseDebitNotePopup = raiseDebitNoteClose()">Cancel</v-btn>
            <v-btn :color="!raise_note_against || !debit_amount || number > 0 ? 'secondry' : 'primary'" size="small" variant="outlined" class="mb-3 text-none" @click="raiseDebitNoteSubmit" :disabled="!raise_note_against || !debit_amount || number > 0">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!--Ok confirm popup -->
    <v-row justify="center">
      <v-dialog v-model="okconfirmpopup" persistent max-width="424px">
        <v-card class="v-card-100 pa-2">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text class="text-center" v-if="(active_tab == 'Not Found Items')">
            <span> Sub location Updated Successfully </span>
          </v-card-text>
          <v-card-text class="text-center"
            v-if="(active_tab == 'Pending Disposition') || (active_tab == 'Pending Dispatch')">
            <span> {{ message }} </span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="flat" class="mb-3 text-none" @click="afterClickOkLoadData">Ok</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!--  Success messeage popup -->
    <v-row justify="center">
      <v-dialog v-model="rejectsussesspopup" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="rejectsussesspopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span> {{ successmessage }}</span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="flat" class="mb-3 text-none" @click="afterClickOkLoadData">Ok</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!--  Cancel Success messeage popup in Request Tracker -->
    <v-row justify="center">
      <v-dialog v-model="cancelSuccesPopup" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="cancelSuccesPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span>Request
              <span v-for="item in temp_selectedData" :key="item" style="font-weight: bold;"> {{
                item.request_id }} </span>
              ? Successfully cancelled.
            </span>
          </v-card-text>

          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="flat" class="mb-3 text-none" @click="cancelSuccesPopup = false">Ok</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- success message -->
    <v-row justify="center">
      <v-dialog v-model="successDialogInward" persistent max-width="480px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="successDialogInward = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-spacer></v-spacer>
          <v-card-text class="text-center">
            <span style="font-weight:500">
              <span> {{ returnId }} </span>
              {{ successMsg }}
            </span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn class="mb-3 text-none" variant="flat" color="primary" small @click="closemsg">Ok</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- error message -->
    <v-row justify="center">
      <v-dialog v-model="errorDialogInward" persistent max-width="480px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="errorDialogInward = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-spacer></v-spacer>
          <v-card-title style="margin-top: -13px;">
            <span style="font-size: initial;" class="text">{{ ErroeMsg }}</span>
          </v-card-title>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="flat" class="text-blue" color="white" size="small" @click="errorDialogInward = false">Ok</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- cancelled tag ids -->
    <v-row justify="center">
      <v-dialog v-model="canseledtagspopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Cancelled Tag IDs</span>
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="canseledtagspopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text>
            <v-container>
              <v-row v-for="(tag, index) in tags" :key="index">
                <v-col cols="12" sm="4" md="6" style="height: 96px;">
                  <v-autocomplete v-model="tag.reject_reason" variant="outlined" :items="reason_forReject_items" item-title="name"
                    item-value="id" :label="'Reason For Reject '" style="max-width: 300px;"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4" md="6" style="height: 96px;">
                  <v-text-field label="Tag Id" variant="outlined" v-model="tag.tag_id" @keydown.enter="addItem(tag)"></v-text-field>
                </v-col>
                <v-row v-if="tag.tag_ids.length > 0">
                  <v-col cols="12" sm="4" md="6"></v-col>
                  <v-col cols="12" sm="4" md="6">
                    <div class="selected_rule_box">
                      <span v-for="(item, index) in tag.tag_ids" :key="index" class="rule-type_option">
                        {{ item }}
                        <v-icon small @click="removeItem(tag, index)">mdi-close</v-icon>
                      </span>
                    </div>
                  </v-col>
                </v-row>
              </v-row>
              <v-row>
                <v-col>
                  <v-btn color="blue" dark class="ma-2 text-none" @click="addMoreTag">
                    <v-icon class="mr-1">mdi-plus-circle</v-icon> Add More
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
            <v-card-actions center>
              <v-spacer></v-spacer>
              <v-btn variant="outlined" color="primary" class="cancel-color text-none mb-3" @click="cancelCansalation">Cancel</v-btn>
              <v-btn color="white" class="mb-3 bg-blue text-none" @click="submitcansalation">Submit</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- data detail popup  -->
    <v-row justify="center">
      <v-dialog v-model="datadetailpopupdisposition" persistent max-width="700px">
        <v-card class="v-card-100">
            <v-card-title class="d-flex align-center">
              <span>Tag ID: {{ tag_number }}</span>
              <v-spacer></v-spacer>
              <v-btn icon variant='solo' @click="datadetailpopupdisposition = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          <v-divider :thickness="2" class="border-opacity-50 m-0"/>
          <v-card-text>
            <v-container>
              <div>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Article id</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ sku_master_code }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Article Description</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ item_description }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Lot ID</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ lot_id }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Lot Name</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ lot_name ? lot_name : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Destination Type</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ destination_type ? destination_type : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Outward Reason Ref Order</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ outward_reason_ref_order ? outward_reason_ref_order : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Pickup Request Status</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ pickup_request_status ? pickup_request_status : '-' }}
                  </v-col>
                </v-row>
                <v-row v-if="active_tab == 'Pending Packaging'">
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Packaging Request Status</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ pickup_request_status ? pickup_request_status : '-' }}
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- data detail popup  for Pending Dispatch and Request Tracker-->
    <v-row justify="center">
      <v-dialog v-model="detailDataPopup" persistent max-width="700px">
        <v-card class="v-card-100">
            <v-card-title class="d-flex align-center">
              <span v-if="active_tab == 'Pending Dispatch'">Box Id: {{ bx_Id }}</span>
              <span v-if="active_tab == 'Request Tracker'">Request Id: {{ reqst_Id }}</span>
              <v-spacer></v-spacer>
              <v-btn icon variant="solo" @click="detailDataPopup = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          <v-divider :thickness="2" class="border-opacity-50 m-0"/>
          <v-card-text>
            <v-container>
              <div>
                <v-row v-if="active_tab == 'Pending Dispatch'">
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">ORRD</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ orrdNumber }}
                  </v-col>
                </v-row>
                <v-row v-if="active_tab == 'Pending Dispatch'">
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Destination Type</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ destType }}
                  </v-col>
                </v-row>
                <v-row v-if="active_tab == 'Pending Dispatch'">
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Destination</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ dest }}
                  </v-col>
                </v-row>
                <v-row v-if="active_tab == 'Request Tracker'">
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Request Type</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ rqustType }}
                  </v-col>
                </v-row>
                <v-row v-if="active_tab == 'Request Tracker'">
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Assigned To</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ assignedTo }}
                  </v-col>
                </v-row>
                <v-row v-if="active_tab == 'Request Tracker'">
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Status</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ status1 }}
                  </v-col>
                </v-row>
                <v-row v-if="active_tab == 'Request Tracker'">
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Distribution Center</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ distribCenter }}
                  </v-col>
                </v-row>
              </div>
              <div v-if="active_tab == 'Pending Dispatch'" class="mt-4">
                <v-data-table hover
                  density="compact"
                  show-select
                  v-model="box_items_selected"
                  :headers="box_items_headers"
                  :items="box_items_list"
                  :loading="box_items_loading"
                  loading-text="Loading Data... Please wait"
                  disable-pagination
                  :hide-default-footer="true"
                  class="elevation-1"
                  return-object
                  >
                  <template #bottom></template>
                </v-data-table>
              </div>
            </v-container>
          </v-card-text>
          <v-card-actions center v-if="active_tab == 'Pending Dispatch' && isActionAllowed(role)">
            <v-spacer></v-spacer>
            <v-btn
              class="text-none"
              color="blue-darken-4"
              rounded="0"
              variant="outlined"
              :disabled="box_items_selected.length == 0"
              @click="deleteBoxItemsORRD">Delete ORRD</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Update Details Popup in Pending Dispatch tab -->
    <v-row justify="center">
      <v-dialog v-model="createUpdateDispatchDetails" persistent max-width="700px">
        <v-card class="v-card-100">
            <v-card-title class="d-flex align-center">
              <span>Dispatch Details</span>
              <v-spacer></v-spacer>
              <v-btn icon variant="solo" @click="createUpdateDispatchDetails = closeUpdateDispatchDetails()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          <v-divider :thickness="2" class="border-opacity-50 m-0"/>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="4" md="6" style="height: 96px;">
                  <v-text-field hide-details color="primary" label="Destination Type" variant="outlined" v-model="destination_type" type="text" :disabled="true"></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="6" style="height: 96px;">
                  <v-text-field hide-details colour="primary" label="Destination" variant="outlined" v-model="destination" type="text" :disabled="true"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" sm="6" md="6" style="height: 96px;">
                  <v-autocomplete v-model="outwordReferenceDocument" color="primary" variant="outlined" :items="outward_ref_item" item-title="name"
                    item-value="id" label="Outward Reference Document" style="max-width: 300px;" disabled
                    @update:modelValue="checkValueChange"
                    :error-messages="showError ? ['You can not change this!'] : []"></v-autocomplete>
                </v-col>
                <v-col cols="6" sm="4" md="6" style="padding: 0px;">
                  <v-col v-for="(field, index) in fields" :key="index" style="height: 96px;">
                    <v-text-field hide-details color="primary" label="ORD Number" variant="outlined" v-model="field.outward_ref_value" required type="text" :min="0" oninput="validity.valid||(value='');" :disabled="outwardDisabled || $isRelianceClient()"></v-text-field>
                  </v-col>
                </v-col>
                <v-row>
                  <v-col cols="6" sm="4" md="6"></v-col>
                  <v-col cols="6" sm="4" md="6">
                    <a @click="addMoreField" :style="$isRelianceClient() ? 'color:gray; pointer-events:none; cursor: not-allowed;' : 'color: #1976d2; text-decoration: underline;'">Add More ORV +</a>
                  </v-col>
                </v-row>
              </v-row>

              <v-row>
                <v-col cols="12" sm="4" md="6" style="height: 96px;">
                  <v-autocomplete color="primary" v-model="mode" variant="outlined" :items="mode_items" item-title="name" item-value="id" @update:modelValue="updateOtherDetail" label="Mode" style="max-width: 300px;" :disabled="modeDisabled"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4" md="6" style="height: 96px;">
                  <v-autocomplete color="primary" v-model="logisticPartner" variant="outlined" :disabled="mode == '2'" :items="logistic_partner_items" item-title="name" item-value="id" label="logistic Partner" style="max-width: 300px;"></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="4" md="6" style="height: 96px;">
                  <v-text-field color="primary" hide-details label="Vehicle Number" variant="outlined" :disabled="mode == '2' || vehicleDisabled" v-model="value_number" oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/g, '');" required></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="6" style="height: 96px;">
                  <v-text-field color="primary" hide-details :label="organization_name ? 'STN' : 'Dispatch Document Number'" variant="outlined" :disabled="mode == '2' || dispatchDocumentDisabled" v-model="dispatch_document_number" required oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/g, '');"></v-text-field>
                </v-col>
              </v-row>
              <v-col cols="12" sm="4" md="6">
                  <v-file-input color="primary" v-model="file" accept="pdf" :label="$isRelianceClient() ? 'ORD' : 'POD'" @change="handleFileChange"></v-file-input>
              </v-col>
              <v-col cols="12" sm="4" md="6">
                <v-btn color="primary" variant="outlined" class="btn-cancel ma-2 text-none" @click="addcancelledtags" disabled> + Add Cancelled Tag IDs</v-btn>
                <div class="mt-2">
                  <span v-if="submittedTags.length > 0" class="text_color text-none" @click="opencanceledtags" style="cursor: pointer;">{{ submittedTags.length }} Canceled Tag ID's </span>
                </div>
              </v-col>
            </v-container>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="outlined" color="primary" class="btn-cancel text-none mb-3"
              @click="createUpdateDispatchDetails = closeUpdateDispatchDetails()">Cancel</v-btn>
            <v-btn 
                :color="outwordReferenceDocument == '' || mode == '' || (mode == '1' && (logisticPartner == ''
                || value_number == '' || dispatch_document_number == '')) || number > 0 || !file || outwordReferenceDocument != intial_value ? 'secondry' : 'primary'" 
                class="mb-3"
                variant="flat"
                :disabled="outwordReferenceDocument == '' || mode == '' || (mode == '1' && (logisticPartner == ''
                || value_number == '' || dispatch_document_number == '')) || !this.fields.every((field) => field.outward_ref_value) || number > 0 || !file || outwordReferenceDocument != intial_value"
              @click="updatePendingDecisionSubmit">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>

        </v-card>
      </v-dialog>
    </v-row>
    <!-- Download popup -->
   <v-row justify="center">
   <v-dialog v-model="downloadDialog" persistent max-width="364px">
         <v-card class="v-card-100">
            <v-card class="v-card-100">
            <v-card-title>
              <v-row class="ma-1">
              <span>Download</span>
              <v-spacer></v-spacer>
              <!-- <v-btn? icon @click="downloadDialog = false"> -->
                <v-icon  @click="downloadDialog = false">mdi-close</v-icon>
              <!-- </v-btn> -->
            </v-row>
            </v-card-title>
          </v-card>
            <v-card-text class="download-email">
                  <v-row>
                     <v-col cols="12" sm="4" md="12">
                        <v-text-field label="Email Id" :rules="emailRules" @input="validateEmail" outlined v-model="email_id" type="text"></v-text-field>
                     </v-col>
                  </v-row>
            </v-card-text>
            <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn small class="text-none" variant="outlined" large color="primary" @click="downloadDialog = false">Cancel</v-btn>
            <v-btn small class="text-none" variant="flat" large color="primary" @click="downloadFile('submit')" :disabled="!isEmailValid || number > 0">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
         </v-card>
   </v-dialog>
</v-row>
 <!-- Delete confirmation popup -->
  <v-row justify="center">
      <v-dialog v-model="ORRD_delete_confirmation" persistent max-width="450px">
          <v-card class="v-card-100">
              <v-card-title class="d-flex">
            <v-spacer></v-spacer>
              <v-icon @click="ORRD_delete_confirmation = false; deleting_box_items = false">mdi-close</v-icon>
          </v-card-title>
              <v-card-text style="text-align:center;">
                <span>  Are you sure you want delete ORRD {{orrd_number}}? </span>
              </v-card-text>
              <v-card-actions>
                 <v-spacer></v-spacer>
                  <v-btn class="text-none"
                    color="blue-darken-4"
                    rounded="0"
                    variant="outlined"
                    @click="ORRD_delete_confirmation = false; deleting_box_items = false"
                    >Cancel</v-btn>
                  <v-btn 
                    class="text-none ms-2 text-white"
                    color="blue-darken-4"
                    rounded="0"
                    variant="flat"
                    @click="deleteORRDAfterConfirm">Confirm</v-btn>
                    <v-spacer></v-spacer>
              </v-card-actions>
          </v-card>
      </v-dialog>
  </v-row>
    <!-- popups end -->
    <!-- Header -->
    <div>
      <HeaderComponent :headerTitle="headerText" />
    </div>
    <!-- tabs -->
    <v-card class="v-card-100">
      <v-tabs color="primary" v-model="selected_tab">
        <v-tab style="text-transform:none!important;" @click="loadData(tab, 'tab_clicked')" v-for="(tab, index) in tabs"
          :key="index" class="tab-color">{{ tab }}</v-tab>
      </v-tabs>
    </v-card>
    <!-- action , search and filter -->
    <v-card-title style="padding: 20px" class="action-style pb-1">
      <v-row>
       <v-combobox class="text-left m-3 mr-0" 
           v-if="active_tab !== 'Pending Dispatch' && active_tab !== 'Request Tracker'"
           v-model="select_field" 
           item-title="name" 
           item-value="id" 
           :items="select_field_items" 
           label="Select Field" 
           variant="outlined" 
           style="max-width: 158px;">
        </v-combobox>
       <v-text-field color="primary" class="m-3" 
            prepend-inner-icon="mdi-magnify"  
            :disabled="!select_field && (active_tab !== 'Pending Dispatch' && active_tab !== 'Request Tracker')" 
            v-model="dispatch_search" 
            v-no-edge-space
            label="Search" 
            style="max-width: 300px;" 
            variant="outlined" 
            v-on:keyup.enter="loadData(active_tab)">
        </v-text-field>
        <v-row>
        <v-spacer></v-spacer>
        <!-- action buttons -->
        <v-card-action class="mt-8">
        <template v-if="active_tab == 'Pending Pick-Up' && isActionAllowed(role)">
        <v-btn class="mr-2 text-none" size="x-large" color="primary" :disabled="selected.length == 0" @click="deleteORRD">Delete ORRD</v-btn>
          <v-btn class="mr-2 text-none" size="x-large" color="primary" :disabled="selected.length == 0" @click="createRequestPopup">Create Pickup Request</v-btn>          
        </template>
        <template v-if="active_tab == 'Pending Packaging' && isActionAllowed(role)">
        <v-btn class="mr-2 text-none" size="x-large" color="primary" :disabled="selected.length == 0" @click="deleteORRD">Delete ORRD</v-btn>
          <v-btn class="mr-2 text-none" size="x-large" color="primary" :disabled="selected.length == 0" @click="createPickuppopup">Create Packaging Request</v-btn>
        </template>
        <template  v-if="active_tab == 'Pending Dispatch' && isActionAllowed(role)">
         <v-btn class="mr-2 text-none" size="x-large" color="primary" :disabled="selected.length == 0" @click="deleteORRD">Delete ORRD</v-btn>
          <v-btn class="mr-2 text-none" size="x-large" color="primary" :disabled="selected.length == 0" @click="createUpdateDetails">Update Dispatch <br class="text-break"> Details</v-btn>
          <v-btn class="mr-2 custum-button" v-if="selected.length > 0" @click="downloadFile('selected')" color="primary" large style="min-height:55px; min-width:130px; font-weight:600;">Download</v-btn>
          <v-btn class="mr-2 custum-button" v-if="selected.length === 0" @click="openPopup" color="primary" large style="min-height:55px; min-width:130px; font-weight:600;">Download</v-btn>
          <v-btn class="mr-2 custum-button" :disabled="(selected.length != 0)" @click="navigateToFileUpload" color="primary" large style="min-height:55px; min-width:100px; font-weight:600;">Upload</v-btn>
        </template>
        <template  v-if="active_tab == 'Request Tracker' && isActionAllowed(role)">
          <v-btn class="mr-2 text-none" size="x-large" color="primary" :disabled="checkIsPending" @click="editRequestDialog">Edit Request</v-btn>
          <v-btn class="mr-2 text-none" size="x-large" color="primary" :disabled="checkIsPending" @click="cancelRequestDialogOpen">Cancel Request</v-btn>
          <v-btn class="mr-2 text-none" size="x-large" color="primary" :disabled="checkIsPending" @click="changeAssignmentFunc">Change Assignment</v-btn>
        </template>
        <template  v-if="active_tab == 'Pending Disposition' && isActionAllowed(role)">
          <v-menu offset-y>
            <template v-slot:activator="{ props }">
              <v-btn class="mr-2 text-none" size="x-large" color="primary" v-bind="props" :disabled="selected.length == 0">
                Assign Disposition
                <v-icon dark color="white">
                  mdi-menu-down
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="(item, index) in assign_disposition_list" :key="index" @click="assignDisposition(item)">
                <v-list-item-title>{{ item.code }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-if="active_tab == 'Not Found Items' && isActionAllowed(role)">
          <v-btn class="mr-2 text-none" size="x-large" color="primary" :disabled="selected.length == 0" @click="updateSubLocationDialog">Update Sub-Location</v-btn>
          <v-btn class="mr-2 text-none" size="x-large" color="primary" :disabled="selected.length == 0 || selected.length > 1" @click="raiseDebitNote">Write Off Item</v-btn>
        </template>
      </v-card-action>
        <!-- action buttons end -->
        <!-- filter -->
        <v-expansion-panels class="custom-control_outlined mr-6 pt-8" ref="filterPopupRef" readonly
          style="max-width: 300px; height: 52px;">
          <v-expansion-panel variant="outlined" @click="filterListOfButtons">
            <v-expansion-panel-title>Filter
            </v-expansion-panel-title>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
      </v-row>
    </v-card-title>
    <!-- tabs data -->
    <v-layout row>
      <!-- <v-flex md6 style="overflow: auto"> -->
        <v-data-table hover
          density="compact"
          :search="search"
          v-model="selected"
          show-select
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data"
          :loading="loading"
          :items-per-page="pageSize"
          fixed-header
          height="100%"
          loading-text="Loading Data... Please wait" class="elevation-1"
          return-object
          > <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers" :key="header.key">
              <span v-if="header.key == 'tag_number'">
                <a href="#" @click.prevent="linkPopupInReqTracker(item)" style="color: #1976d2 !important; cursor: pointer !important;"><u>{{ item.tag_number }}</u></a>
              </span> 
              <span v-else-if="header.key == 'request_id'">
                <a href="#" @click.prevent="openDataDetails(item, 'requestTracker')" style="color: #1976d2 !important; cursor: pointer !important;"><u> {{ item.request_id }}</u></a>
              </span> 
              <span v-else-if="header.key == 'box_number'">
                <a href="#" @click.prevent="openDataDetails(item, 'pendingDispatch')" style="color: #1976d2 !important; cursor: pointer !important;"><u> {{ item.box_number }}</u></a>
              </span>
              <span v-else-if="header.key == 'lot_name'">
                <span>{{item.lot_name ? item.lot_name : '-'}}</span>
              </span>  
              <span v-else-if="header.key !== 'tag_number' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
              <span v-else>-</span>
            </template>
          <template #bottom></template>
        </v-data-table>
      <!-- </v-flex> -->
    </v-layout>
    <!-- tabs data end -->
    <!-- filter data popup -->
    <v-row justify="center">
      <v-dialog content-class="filter-dispatch" v-model="filteWithSubPopup" persistent max-width="900px">
        <v-card class="filter_ui">
          <v-card-actions v-if="active_tab == 'Pending Pick-Up'">
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="lot_name_search" label="Lot Name" class="ma-2" variant="outlined"></v-text-field>
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="outward_reason_ref_search" label="Outward Reason Ref Order" class="ma-2" variant="outlined"></v-text-field>
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="destination_type_search" label="Destination Type" class="ma-2" variant="outlined"></v-text-field>
            <v-combobox clearable v-model="filterPickupRequestStatus" :items="pickup_request_status" item-title="name" item-value="id" label="Pick Up Request Status" variant="outlined" class="ma-2"></v-combobox>
            <v-combobox clearable v-model="disposition_filter" :items="disposition_filter_items" label="Disposition" variant="outlined" class="ma-2"></v-combobox>
          </v-card-actions>
          <v-card-actions v-if="active_tab == 'Pending Packaging'">
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="lot_name_search" label="Lot Name" class="ma-2" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="outward_reason_ref_search" label="Outward Reason Ref Order" class="ma-2" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="destination_type_search" label="Destination Type" class="ma-2" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
            <v-combobox clearable v-model="filterPackagingRequestStatus" :items="packaging_request_status" item-title="name" item-value="id" label="Packaging Request Status" variant="outlined" class="ma-2" v-on:keyup.enter="loadData(active_tab)" v-if="active_tab == 'Pending Packaging'"></v-combobox>
            <v-combobox clearable v-model="disposition_filter" :items="disposition_filter_items" label="Disposition" variant="outlined" class="ma-2"></v-combobox>
          </v-card-actions>
          <v-card-actions v-if="active_tab == 'Pending Dispatch'">
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="outward_reason_ref_search" label="ORRD" class="ma-2" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="destination_type_search" label="Destination Type" class="ma-2" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="destination_items" label="Destination" class="ma-2" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
            <v-combobox clearable v-model="disposition_filter" :items="disposition_filter_items" label="Disposition" variant="outlined" class="ma-2"></v-combobox>
          </v-card-actions>
          <v-card-actions v-if="active_tab == 'Request Tracker'">
            <v-combobox clearable v-model="request_type_search" :items="filter_request_types" item-title="name" item-value="id" label="Request Type" variant="outlined" class="ma-2" v-on:keyup.enter="loadData(active_tab)"></v-combobox>
            <v-combobox clearable v-model="status_search" :items="filter_status" item-title="name" item-value="id" label="Status" variant="outlined" class="ma-2" v-on:keyup.enter="loadData(active_tab)"></v-combobox>
          </v-card-actions>
          <v-card-actions v-if="active_tab == 'Pending Disposition'">
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="article_id_search" label="Article ID" class="ma-2" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field> 
            <v-combobox clearable  variant="outlined" v-model="reason_for_reject_search" :items="filter_reject_reason" item-title="name" item-value="id" label="Reason For Reject" outlined class="ma-2" v-on:keyup.enter="loadData(active_tab)"></v-combobox>
          </v-card-actions>
          <v-card-actions v-if="active_tab == 'Not Found Items'">
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="article_id_notfound_search" label="Article ID" class="ma-2" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
            <v-combobox clearable v-model="category_search" :items="filter_category" item-title="value" item-value="key" label="Category" multiple variant="outlined" class="ma-2" v-on:keyup.enter="loadData(active_tab)" ref="brandAutocomplete"></v-combobox>
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn small color="normal" variant="outlined" class=" text-none" @click="filteWithSubPopup = filterPopupClose()">Cancel</v-btn>
            <v-btn small color="primary" variant="flat" class=" text-none" @click="applyFilterFunc">Apply Filter(s)</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- <v-row justify="center">
      <v-dialog content-class="filter-dispatch" color="primary" v-model="filteWithSubPopup" persistent max-width="900px">
        <v-card>
          <v-card-actions v-if="active_tab == 'Pending Pick-Up'">
            <v-row>
              <v-col> 
                <v-text-field prepend-inner-icon="mdi-magnify" color="primary" v-model="lot_name_search" label="Lot Name" class="ma-2" variant="outlined"></v-text-field>
              </v-col>
              <v-col>
                <v-text-field prepend-inner-icon="mdi-magnify" color="primary" v-model="outward_reason_ref_search" label="Outward Reason Ref Order" class="ma-2" variant="outlined"></v-text-field>
              </v-col>
              <v-col>
                <v-text-field prepend-inner-icon="mdi-magnify" color="primary" v-model="destination_type_search" label="Destination Type" class="ma-2" variant="outlined"></v-text-field>
              </v-col>
              <v-col>
                <v-combobox clearable color="primary" v-model="filterPickupRequestStatus" :items="pickup_request_status" item-title="name" item-value="id" label="Pick Up Request Status" variant="outlined" class="ma-2"></v-combobox>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-actions v-if="active_tab == 'Pending Packaging'">
            <v-row>
              <v-col>
                <v-text-field prepend-inner-icon="mdi-magnify" color="primary" v-model="lot_name_search" label="Lot Name" class="ma-2" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
              </v-col>
              <v-col>
                <v-text-field prepend-inner-icon="mdi-magnify" color="primary" v-model="outward_reason_ref_search" label="Outward Reason Ref Order" class="ma-2" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
              </v-col>
              <v-col>
                <v-text-field prepend-inner-icon="mdi-magnify" color="primary" v-model="destination_type_search" label="Destination Type" class="ma-2" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
              </v-col>
              <v-col>
                <v-combobox clearable color="primary" v-model="filterPackagingRequestStatus" :items="packaging_request_status" item-title="name" item-value="id" label="Packaging Request Status" variant="outlined" class="ma-2" v-on:keyup.enter="loadData(active_tab)" v-if="active_tab == 'Pending Packaging'"></v-combobox>
              </v-col>
            </v-row>  
          </v-card-actions>
          <v-card-actions v-if="active_tab == 'Pending Dispatch'">
            <v-row>
              <v-col>
                <v-text-field prepend-inner-icon="mdi-magnify" color="primary" v-model="outward_reason_ref_search" label="ORRD" class="ma-2" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
              </v-col>
              <v-col>
                <v-text-field prepend-inner-icon="mdi-magnify" color="primary" v-model="destination_type_search" label="Destination Type" class="ma-2" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
              </v-col>
              <v-col>
                <v-text-field prepend-inner-icon="mdi-magnify" color="primary" v-model="destination_items" label="Destination" class="ma-2" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-actions v-if="active_tab == 'Request Tracker'">
            <v-row>
              <v-col>
                <v-combobox clearable color="primary" v-model="request_type_search" :items="filter_request_types" item-title="name" item-value="id" label="Request Type" variant="outlined" class="ma-2" v-on:keyup.enter="loadData(active_tab)"></v-combobox>
              </v-col>
              <v-col>
                <v-combobox clearable color="primary" v-model="status_search" :items="filter_status" item-title="name" item-value="id" label="Status" variant="outlined" class="ma-2" v-on:keyup.enter="loadData(active_tab)"></v-combobox>
              </v-col>
          </v-row>
          </v-card-actions>
          <v-card-actions v-if="active_tab == 'Pending Disposition'">
            <v-row>
              <v-col>
                <v-text-field prepend-inner-icon="mdi-magnify" color="primary" v-model="article_id_search" label="Article ID" class="ma-2" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field> 
              </v-col>
              <v-col>
                <v-combobox clearable color="primary" v-model="reason_for_reject_search" :items="filter_reject_reason" item-title="name" item-value="id" label="Reason For Reject" variant="outlined" class="ma-2" v-on:keyup.enter="loadData(active_tab)"></v-combobox>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-actions v-if="active_tab == 'Not Found Items'">
            <v-row>
              <v-col>
                <v-text-field prepend-inner-icon="mdi-magnify" color="primary" v-model="article_id_notfound_search" label="Article ID" class="ma-2 w-50" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
              </v-col>
              <v-col>
                <v-combobox clearable color="primary" v-model="category_search" :items="filter_category" item-title="value" item-value="key" label="Category" multiple variant="outlined" class="ma-2 w-50" v-on:keyup.enter="loadData(active_tab)" ref="brandAutocomplete"></v-combobox>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn size="small" variant="outlined" class="text-none" color="normal" @click="filteWithSubPopup = filterPopupClose()">Cancel</v-btn>
            <v-btn size="small" variant="flat" class="text-none" color="primary" @click="applyFilterFunc">Apply Filter(s)</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row> -->
    <!-- pagination display -->
    <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-6 mb-0"
                />
  </v-card>
</template>
<script>
  import { securedAxiosInstance } from '@/backend/axios'
  import HeaderComponent from '../../../../commoncomponents/HeaderComponent.vue';
   import { moduleAccessFunc,module_that_allowed,signout,isOnlyViewAction } from '@/backend/axios/moduleAccess'
   import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
  // import { moduleAccessFunc,module_that_allowed,signout } from '@/backend/axios/moduleAccess';

  export default {
    data() {
      return {
        headerText: "Dispatch",
        tabs: [
          "Pending Pick-Up",
          "Pending Packaging",
          "Pending Dispatch",
          "Request Tracker",
          "Pending Disposition",
          "Not Found Items"
        ],
        active_tab: "Pending Pick-Up",
        headers: [],
        search: '',
        filteWithSubPopup: false,
        table_data: [],
        dispatch_search: '',
        loading: true,
        alert: false,
        alert_type: "success",
        alert_message: "success",
        selctedItemsPopup: false,
        selected_table_data: [],
        selected: [],
        filterLotName: [],
        filterOutwardReasonReforder: [],
        filterDestinationType: [],
        filterPickupRequestStatus: [],
        filterDestination: [],
        lot_name: [],
        lot_name_search: '',
        box_id_search: '',
        selected_tab : 0,
        destination_type_search: '',
        outward_reason_ref_order: '',
        destination_type: '',
        pickup_request_status: '',
        assignExecutivePopup: false,
        assignExecutivePopup_2: false,
        editRequestPopup: false,
        addMoreItemsPopup: false,
        selected_add: [],
        add_item_search: '',
        request_sl_id: '',
        distributionCenterId: '',
        add_items_table_data: [],
        add_items_headers: [],
        changeAssignmentPopup: false,
        change_assignment: [],
        change_assignment_items: '',
        dc_id: '',
        inv_id: [],
        sub_location: [],
        successMsg: '',
        ErroeMsg: '',
        successDialogInward: false,
        errorDialogInward: false,
        update_inv_id: [],
        changeAssignmentEditPopup: false,
        change_assignment_item_edit: [],
        change_assignment_edit_items: [],
        cancelRequestPopup: false,
        selectedDisposition: '',
        addMoreItemsPopup: false,
        request_reason_name: '',
        datadetailpopupdisposition: false,
        item_details: '',
        pageSize: defaultPageSize,
        pageSizes: defaultPageSizes,
        page: 1,
        totalPages: 1,
        totalCount: '',
        updateSubLocation: false,
        update_sub_location: '',
        sub_location: '',
        okconfirmpopup: false,
        dispatch_id: [],
        request_id_search: '',
        request_type_search: '',
        status_search: [],
        tag_id_search: '',
        article_id_search: '',
        reason_for_reject_search: [],
        category_search: [],
        createPendingpackaging: false,
        writeOffItemDialog: false,
        inwardSelected: false,
        raiseDebitNotePopup: false,
        raise_note_against: '',
        debit_amount: '',
        request_ids: [],
        filter_request_types: '',
        filter_status: '',
        filter_reject_reason: '',
        filter_category: '',
        requestReason: 'Packaging',
        assignTo: [],
        createUpdateDispatchDetails: false,
        put_request: [],
        outward_reason_ref_search: '',
        request_type: '',
        assignee_ids: '',
        value_number: [],
        dispatch_document_number: [],
        canseledtagspopup: false,
        reject_reason: '',
        reason_forReject_items: [],
        rows: [{ file: '', }],
        outward_ref_item: '',
        outwordReferenceDocument: [],
        mode_items: '',
        mode: [],
        logistic_partner_items: '',
        logisticPartner: '',
        filterPackagingRequestStatus: [],
        destination_items: '',
        edit_req_table_data: '',
        lot_id: '',
        sku_master_code: '',
        item_description: '',
        selected_headers: [],
        edit_req_headers: [],
        destination: [],
        tag_number: '',
        rejectsussesspopup: false,
        file: '',
        number: 0,
        temp_selectedData: [],
        // outward_ref_value: [],
        fields: [
          { outward_ref_value: '' } // Initial field
        ],
        tags: [
          {
            reject_reason: '',
            tag_ids: []
          },
        ],
        tag_id: [],
        submittedTags: [],
        req_id: '',
        items_to_add: [],
        edit_req_table_data: [],
        article_id_notfound_search: '',
        tag_items: [],
        cancelSuccesPopup: false,
        detailDataPopup: false,
        bx_Id: '',
        reqst_Id: '',
        returnId: '',
        rqustType: '',
        orrdNumber: '',
        destType: '',
        dest: '',
        box_items_headers: [
          { title: "Tag Id", key: "tag_number" },
          { title: "Article Id", key: "sku_master_code" },
          { title: "Article Description", key: "item_description" },
          { title: "Serial Number", key: "serial_number" },
        ],
        box_items_list: [],
        box_items_selected: [],
        box_items_loading: false,
        deleting_box_items: false,
        message: '',
        intial_value: '',
        showError: false,
        temp_cancelled_tag: [],
        itemSize: 10,
        itemSizes: [5, 10, 15],
        totalCount: '',
        totalItemCount: '',
        totalItems: 1,
        item: 1,
        snackbar: false,
        snackbar: {
          color: null,
          icon: null,
          mode: null,
          position: "top",
          text: null,
          timeout: 7500,
          title: null,
          visible: false
        },
        modeDisabled: false,
        vehicleDisabled: false,
        dispatchDocumentDisabled: false,
        outwardDisabled: false,
        role:'',
        downloadDialog:false,
        email_id:'',
        disposition_filter:null,
        disposition_filter_items:[],
        applied_filter:false,
        ORRD_delete_confirmation:false,
        orrd_number:'',
        tab_name:'',
        select_field_items: [
                 {
                    "name":"Tag ID",
                    "id": "tag_number"
                  },
                  {
                    "name":"ORRD Number",
                    "id": "orrd_number"
                  }
          ],
          select_field:null,
      }
    },
    async created() {
      this.role = this.$store.state.currentUser.roles[0]
      if(this.role in module_that_allowed && moduleAccessFunc(this.role,'Dispatch')){
        signout()
        return;
      }
      this.successmessage = this.$store.state.responseMessage;
      if (this.successmessage !== undefined && this.successmessage !== '') {
        this.successpopup = true
      } else if (this.successmessage === undefined) {
        this.successpopup = false
      }
      this.organization_name = this.$store.state.organization_name
      const tab = this.$store.state.active_tab
      if(this.tabs.includes(tab)){
        this.loadData(tab);
        this.selected_tab = this.tabs.indexOf(tab)
      } else {
        this.loadData('Pending Pick-Up');
        this.selected_tab = 0
      }
      this.scrollToTop();
      // this.get_categories_list();
    },
    components: {
      HeaderComponent
    },
    watch: {
      assignTo(newValue) {
        if (newValue && newValue.length > 0) {
          this.$nextTick(() => {
            this.$refs.brandAutocomplete.internalSearch = '';
          });
        }
      },
      change_assignment(newValue) {
        if (newValue && newValue.length > 0 && this.$refs.brandAutocomplete) {
          this.$nextTick(() => {
            this.$refs.brandAutocomplete.internalSearch = '';
          });
        }
      },
      change_assignment_item_edit(newValue) {
        if (newValue && newValue.length > 0 && this.$refs.brandAutocomplete) {
          this.$nextTick(() => {
            if(this.$refs.brandAutocomplete){
              this.$refs.brandAutocomplete.internalSearch = '';
            }
          });
        }
      },
      category_search(newValue) {
        if (newValue && newValue.length > 0) {
          this.$nextTick(() => {
            this.$refs.brandAutocomplete.internalSearch = '';
          });
        }
      },
      itemSize() {
        this.handleItemSizeChange(this.itemSize);
      },
      item() {
        this.handleItemChange(this.item);
      }
    },
  computed: {
  checkIsPending() {
    if (this.selected.length === 0) {
      return true;
    }
        const isAnyNotPending = this.selected.some(item => item.status != "Pending");
    return isAnyNotPending;
  },
  pagedData() {
    const start = (this.item - 1) * this.itemSize;
    const end = this.item * this.itemSize;
    return this.selected_table_data.slice(start, end);
  }
},
methods: {
      isActionAllowed(){
        return !isOnlyViewAction(this.role, 'Dispatch')
      },
      checkValueChange() {
        if (this.outwordReferenceDocument == this.intial_value) {
          this.showError = false;
        } else {
          this.showError = true;
        }
      },
      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      },
      eraseAssign(selectedItems) {
        if (selectedItems.length > 0) {
          this.assignTo = selectedItems;
        } else {
          this.assignTo = '';
        }
      },
      addItem(tag) {
        if (tag.tag_id.trim() !== '') {
          tag.tag_ids.push(tag.tag_id.trim())
          tag.tag_id = ''
        }
      },
      removeItem(tag, index) {
        tag.tag_ids.splice(index, 1)
      },
      loadData(tab, tab_action) {
        if (tab_action) {
          this.dispatch_search = '';
          this.lot_name_search = '';
          this.outward_reason_ref_search = '';
          this.destination_type_search = '';
          this.filterPickupRequestStatus = '';
          this.disposition_filter = null;
          this.select_field = null;
          this.page= 1;
          this.pageSize = defaultPageSize;
        }
        this.loading = true;
        this.selected = []
        this.active_tab = tab
        this.table_data = []
        this.page = 1;
        this.totalPages = 0,
        this.applied_filter = false;
        this.$store.commit('setActiveTab',{
          'active_tab' : tab
        })
        if (tab == "Pending Pick-Up") {
          (this.headers = [
            { title: "Tag ID", key:"tag_number", minWidth:"120px" },
            { title: "Lot ID", key:"lot_id", minWidth:"120px" },
            { title: "Lot Name", key:"lot_name", minWidth:"120px"  },
            { title: "Outward Reason Ref Order", key:"outward_reason_ref_order", minWidth:"300px" , },
            { title: "Destination Type", key:"destination_type", minWidth:"200px"  },
            { title: "Pick Up Request Status", key:"pickup_request_status", minWidth:"300px"  },
            { title: "Disposition", key: "disposition", minWidth:"200px" },
            { title: "Sub Location", key: "sub_location", minWidth:"200px"  },
          ]);
          this.PendingPickUP();
          this.Loadfilterdata();
        }
        if (tab == "Pending Packaging") {
          (this.headers = [
            { title: "Tag ID", key:"tag_number", minWidth:"120px"  },
            { title: "Lot ID", key:"lot_id", minWidth:"120px"  },
            { title: "Lot Name", key:"lot_name", minWidth:"120px"  },
            { title: "Outward Reason Ref Order", key:"outward_reason_ref_order", minWidth:"300px"  },
            { title: "Destination Type", key:"destination_type", minWidth:"200px"  },
            { title: "Packaging Request Status", key:"pickup_request_status", minWidth:"300px"  },
            { title: "Disposition", key: "disposition", minWidth:"200px"},
          ]);
          this.PendingPackaging();
        }
        if (tab == "Pending Dispatch") {
          (this.headers = [
            { title: "Box Id", key:"box_number", minWidth:"120px"  },
            { title: "ORRD", key:"orrd", minWidth:"120px"  },
            { title: "Destination Type", key:"destination_type", minWidth:"200px"  },
            // { title: "Destination", key:"destination", minWidth:"160px"  },
            { title: "Disposition", key: "disposition", minWidth:"200px"},
            { title: "ORD Request ID", key: "ord_request_id", minWidth:"180px"},
            { title: "Outwarding Confirmation Request ID", key: "outward_confirmation_request_id", minWidth:"280px"},
            { title: "Status", key: "status", minWidth:"160px"},
          ]);
          this.PendingDispatch();
          this.fetchDocumentRefernce();
        }
        if (tab == "Request Tracker") {
          (this.headers = [
            { title: "Request ID", key:"request_id", minWidth:"120px"  },
            { title: "Creation Date & Time", key:"created_at", minWidth:"300px"  },
            { title: "Request Type", key:"request_type", minWidth:"200px"  },
            { title: "Assigned To", key:"assignee_name", minWidth:"200px"  },
            { title: "Status", key:"status" },
            { title: "Completion Date & Time", key:"completed_at", minWidth:"250px"  },
            { title: "Not Found Items", key:"not_found_items", minWidth:"200px"  },
          ]);
          this.fetchRequestTracker();
          this.fetchFilterRequestType();
        }
        if (tab == "Pending Disposition") {
          (this.headers = [
            { title: "Tag ID", key:"tag_number", minWidth:"120px"  },
            { title: "Article ID", key:"sku_master_code", minWidth:"160px"  },
            { title: "Article Description", key:"item_description" , minWidth:"250px" },
            { title: "Reason for Reject", key:"reject_reason", minWidth:"250px"  },
          ]);
          this.fetchPendingDisposition();
          this.assignDispositionList();
          this.fetchFilterReasonForReject();
        }
        if (tab == "Not Found Items") {
          (this.headers = [
            { title: "Tag ID", key:"tag_number", minWidth:"120px"  },
            { title: "Last Sub-Location", key:"sub_location", minWidth:"200px"  },
            { title: "Category", key:"category" },
            { title: "Article ID", key:"sku_master_code", minWidth:"160px"  },
            { title: "Article Description", key:"item_description", minWidth:"250px"  },
          ]);
          this.fetchNotFoundItems();
          this.fetchFilterCategory();
        }
      },
      filterListOfButtons() {
        this.filterLotName = [],
          this.filterOutwardReasonReforder = [],
          this.filterDestinationType = '',
          this.filterPickupRequestStatus = null,
          this.filteWithSubPopup = true;
        this.lot_name_search = '';
        this.outward_reason_ref_search = '';
        this.destination_type_search = '';
        this.filterPackagingRequestStatus = null;
        this.box_id_search = '';
        this.destination_items = '';
        this.request_type_search = null;
        this.status_search = null;
        this.article_id_search = '';
        this.reason_for_reject_search = null;
        this.article_id_notfound_search = '';
        this.category_search = [];
        document.documentElement.style.setProperty('--dialog-ypos', (this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 20).toString() + 'px');
      },

      PendingPickUP() {
        this.loading = true;
        this.search = '';
        const requestBody = {
          page: this.page,
          per_page: this.pageSize,
          tab: "pending_pickup"
        };
        if(this.dispatch_search){
            requestBody[this.select_field.id] = this.dispatch_search.trim()
        }
        this.$httpSecured
          .get('/api/v1/warehouse/dispatch/fetch_orders', { params: requestBody })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.warehouse_order_items;
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count;
              this.makeLoadingFalse();
            } else {
              this.showAlert("error", "No Data Found");
              this.loading = false;
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      PendingPackaging() {
        this.loading = true;
        this.search = '';
        const requestBody = {
          page: this.page,
          per_page: this.pageSize,
          tab: "pending_packaging"
        };
        if(this.dispatch_search){
            requestBody[this.select_field.id] = this.dispatch_search.trim()
        }
        this.$httpSecured
          .get('/api/v1/warehouse/dispatch/fetch_orders', { params: requestBody })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.warehouse_order_items;
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count;
              this.filterLotName = response.data.warehouse_order_items.map(warehouse_order_items => warehouse_order_items.lot_name);
              this.filterOutwardReasonReforder = response.data.warehouse_order_items.map(warehouse_order_items => warehouse_order_items.outward_reason_ref_order);
              this.filterDestinationType = response.data.warehouse_order_items.map(warehouse_order_items => warehouse_order_items.destination_type);
              this.makeLoadingFalse();
            } else {
              this.showAlert("error", "No Data Found");
              this.loading = false;
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      PendingDispatch() {
        this.loading = true;
        this.search = '';
        const requestBody = {
          box_number: this.dispatch_search,
          page: this.page,
          per_page: this.pageSize,
          tab: "pending_dispatch"
        };
        this.$httpSecured
          .get('/api/v1/warehouse/dispatch/dispatch_boxes', { params: requestBody })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.dispatch_boxes;
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count;
              this.filterDestination = response.data.dispatch_boxes.map(dispatch_boxes => dispatch_boxes.destination);
              this.makeLoadingFalse();
            } else {
              this.showAlert("error", "No Data Found");
              this.loading = false;
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },

      // Fetch the table data for Request-tracker tab
      addMoreItems() {
        this.selctedItemsPopup = false;
        this.selctedItemsPickup = false;
        this.writeOffItemDialog = false;
        this.editRequestPopup = false;
      },
      pickupaddMoreItems() {
        this.selctedItemsPopup = false;
      },
      packagingaddMoreItems() {
        this.createPendingpackaging = false;
      },
      addNewRow() {
        this.rows = [
          ...this.rows,
          {
            file: '',
          }
        ];
      },
      // delete Items
      deleteRequest() {
        if (this.selected.length > 0) {
          this.selected = []
          var input = document.querySelectorAll('.checkbox');
          for (var i = 0; i < input.length; i++) {
            input[i].checked = false;
            this.createPendingpackaging = false;
            this.writeOffItemDialog = false;
          }
        }
        this.createPendingpackaging = false;
        this.writeOffItemDialog = false;
      },
      deleteRequestpickup() {
        if (this.selected.length > 0) {
          this.selected = []
          var input = document.querySelectorAll('.checkbox');
          for (var i = 0; i < input.length; i++) {
            input[i].checked = false;
            this.selctedItemsPopup = false;
          }
        }
        this.selctedItemsPopup = false;
      },
      deleteReqTracker() {
        this.$httpSecured.delete("api/v1/warehouse/put_requests/" + this.request_sl_id)
          .then(response => {
            if (response.data) {
              this.editRequestPopup = false
              this.inv_id = '';
              this.change_assignment = '';
              var input = document.querySelectorAll('.checkbox');
              for (var i = 0; i < input.length; i++) {
                input[i].checked = false;
                this.requestTracListSelected = false;
              }
              this.showAlert("success", "Successfully deleted");
              this.loadData(this.active_tab);
            } else {
              this.showAlert("error", "No Data Found");
            }
          }).catch(error => {
            this.showAlert("error", "Something went wrong from Network");
            this.loading = false;

          });


        // if (this.selected.length > 0) {
        //   this.selected = []
        //   var input = document.querySelectorAll('.checkbox');
        //   for (var i = 0; i < input.length; i++) {
        //     input[i].checked = false;
        //   }
        // }
      },
      // Fetch the table data 
      fetchRequestTracker() {
        this.loading = true;
        this.search = ''
        const requestBody = {
          request_id: this.dispatch_search,
          page: this.page,
          per_page: this.pageSize,
          tab: this.active_tab,
          dispatch_requests: true,
        };
        this.$httpSecured
          .get('/api/v1/warehouse/put_requests', { params: requestBody })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.put_requests
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count
              this.makeLoadingFalse();
            } else {
              this.showAlert("error", "No Data Found");
              this.loading = false;
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },

      // fetch table-data for Pending-Disposition
      fetchPendingDisposition() {
        this.loading = true;
        this.search = ''
        const requestBody = {
          page: this.page,
          per_page: this.pageSize,
          tab: "pending_disposition"
        };
        if(this.dispatch_search){
            requestBody[this.select_field.id] = this.dispatch_search.trim()
        }
        this.$httpSecured
          .get('/api/v1/warehouse/dispatch/fetch_orders', { params: requestBody })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.warehouse_order_items
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count
              this.makeLoadingFalse();
            } else {
              this.showAlert("error", "No Data Found");
              this.loading = false;
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },

      // Fetch Table-data for Not-found-items Tab
      fetchNotFoundItems() {
        this.loading = true;
        this.search = ''
        const requestBody = {
          page: this.page,
          per_page: this.pageSize,
          tab: "not_found_items"
        };
        if(this.dispatch_search){
            requestBody[this.select_field.id] = this.dispatch_search.trim()
        }
        this.$httpSecured
          .get('/api/v1/warehouse/dispatch/fetch_orders', { params: requestBody })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.warehouse_order_items
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count
              this.makeLoadingFalse();
            } else {
              this.showAlert("error", "No Data Found");
              this.loading = false;
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },

      // fetch filter request-type and status in Request-tracker tab
      fetchFilterRequestType() {
        this.$httpSecured
          .get("/api/v1/warehouse/put_requests/filters_data")
          .then(response => {
            if (response.data) {
              this.filter_request_types = response.data.request_types
              this.filter_status = response.data.statuses
              // this.makeLoadingFalse();
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },

      // fetch filter Reson for reject in Pending-Disposition tab
      fetchFilterReasonForReject() {
        this.$httpSecured
          .get("/api/v1/warehouse/dispatch/get_filters_data")
          .then(response => {
            if (response.data) {
              this.filter_reject_reason = response.data.reject_reasons
              // this.makeLoadingFalse();
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },

      // fetch filter category in not-found-items tab
      fetchFilterCategory() {
        this.$httpSecured
          .get("/api/v1/warehouse/put_away/filters_data")
          .then(response => {
            if (response.data) {
              this.filter_category = response.data.categories
              // this.makeLoadingFalse();
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },

      // Edit Request in Request Tracker
      editRequestDialog() {
        this.number = 0;
        this.edit_req_table_data = [];
        this.request_sl_id = this.selected.map(x => x.id)
        var req_id_1 = this.selected.map(x => x.request_id)
        let value = req_id_1[0];
        this.req_id = value;
        const unique = (value, index, self) => {
          return self.indexOf(value) === index
        }
        if (this.selected.length == 1) {
          this.editRequestPopup = true;
          this.assign_user = 'EDIT REQUEST';

        } else {
          var input = document.querySelectorAll('.checkbox');
          for (var i = 0; i < input.length; i++) {
            input[i].checked = false;
            this.selected = []
            this.requestTracListSelected = false;
          }
          this.showAlert("error", "Select only One items");
          return
        }

        this.loading = true;
        this.edit_req_headers = [

          { title: "", key: "customcheck", width: "3%" },
          {
            title: "Tag ID",
            key: "tag_number",
            align: "start",
            sortable: false,
            width: "12%"
          },
          { title: "Category", key: "category" },
          { title: "Article ID", key: "sku_code" },
          { title: "Article Description", key: "item_description" },
          { title: "Grade", key: "grade" },
          { title: "Sub Location", key: "sub_location" },
          { title: 'Delete', key: 'action' }

        ];
        securedAxiosInstance.get("/api/v1/warehouse/put_requests/" + this.request_sl_id)
          .then(response => {
            this.edit_req_table_data = response.data.put_request.request_items
            this.selected = this.edit_req_table_data;
            this.change_assignment_item_edit = response.data.put_request.assignee_ids
            this.update_inv_id = this.edit_req_table_data.map(x => x.inventory_id)
            this.request_ids = this.edit_req_table_data.map(x => x.id)
            this.change_assignment = response.data.put_request.assignee_id;
            this.distributionCenterId = response.data.put_request.distribution_center_id
            this.loading = false;
          })
          .catch(error => this.$toast.error('Error in retrieving data'))
      },

      // SAVE & UPDATE IN THE EDIT REQUEST IN REQUEST-TRACKER TAB
      editrequestSave() {
        this.number++;
        const formData = new FormData();
        const temp_inventory_id = this.edit_req_table_data.map(x => x.warehouse_order_item_id)
        if (temp_inventory_id.length == 0) {
          this.editRequestPopup = false
          this.showAlert("error", "Request should have atleast 1 item");
          return;
        }
        this.$httpSecured.put("api/v1/warehouse/put_requests/" + this.request_sl_id, {
          "put_request": {
            "assignee_ids": this.change_assignment_item_edit,
            "inventory_ids": temp_inventory_id
          }
        },)
          .then(response => {
            if (response.data) {
              this.editRequestPopup = false
              this.inv_id = '';
              this.change_assignment = '';
              this.change_assignment_item_edit = ''
              var input = document.querySelectorAll('.checkbox');
              for (var i = 0; i < input.length; i++) {
                input[i].checked = false;
                this.requestTracListSelected = false;
              }
              this.showAlert("success", `Request ${this.req_id} has been updated successfully.`);
              this.loadData(this.active_tab);
            } else {
              // this.editRequestPopup = false
              this.number = 0;
              this.$toast.error("No Data Found");
              // this.showAlert("error", "No Data Found");
            }
          }).catch(error => {
            // this.editRequestPopup = false
            this.$toast.error(error.response.data.error)
            this.number = 0;
            this.loading = false;

          });
      },
      addMoreField() {
        this.fields.push({ outward_ref_value: '' }); // Add a new field
      },
      addMoreTag() {
        this.tags.push({
          reject_reason: '',
          tag_ids: [],
        });
      },
      // add cancelled tags
      addcancelledtags() {
        const allTagIds = this.submittedTags.map(tag => tag.tag_ids);
        this.reject_reason = '',
          this.destination = "",
          this.canseledtagspopup = true;
        this.$httpSecured
          .get('/api/v1/warehouse/dispatch/get_filters_data')
          .then(response => {
            if (response.data) {
              this.reason_forReject_items = response.data.reject_reasons;
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      // Add item in the edit request in REquest-tracker tab
      addMoreItemsReqTrack() {
        this.addMoreItemsPopup = true;
        this.loading = true;
        this.selected_add = [];
        const params = this.getRequestParams(
          this.page,
          this.pageSize
        );
        this.add_items_headers = [
          {
            title: "Tag ID",
            key: "tag_number",
            align: "start",
            sortable: false,
            width: "12%"
          },
          { title: "Category", key: "category" },
          { title: "Article ID", key: "sku_master_code" },
          { title: "Article Description", key: "item_description", width: "15%" },
          // { title: "Grade", key: "grade" },
          { title: "Sub Location", key: "sub_location" },
          { title: "Site Location", key: "distribution_center" }
        ];
        securedAxiosInstance.get('/api/v1/warehouse/dispatch/' + this.request_sl_id + '/add_items', { params: { search: this.add_item_search, page: params['page'], per_page: params['size'], distribution_center_id: this.distributionCenterId } })
          .then(response => {
            this.add_items_table_data = response.data.warehouse_order_items
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count
            this.loading = false;
            this.add_item_search = ''
          })
          .catch(error => this.$toast.error('Error in retrieving data'))
      },

      //  add button in edit request in Request-tracker tab
      addButton() {
        const mergedItems = [...this.edit_req_table_data, ...this.items_to_add, ...this.selected_add];
        this.edit_req_table_data = Array.from(new Set(mergedItems));
        this.addMoreItemsPopup = false;
      },

      // function called when clicked on the Assignment button in Request Tracker
      changeAssignmentFunc() {
        if (this.selected.length <= 0) {
          this.showAlert('warning', 'Please Select Item First')
          return
        }
        var dc = this.selected.map(x => x.distribution_center_id)
        const unique = (value, index, self) => {
          return self.indexOf(value) === index
        }
        dc = dc.filter(function (element) {
          return element !== undefined;
        });

        var unique_array = dc.filter(unique)
        // if (unique_array.length > 1) {
        //   this.selected = []
        //   var input = document.querySelectorAll('.checkbox');
        //   for (var i = 0; i < input.length; i++) {
        //     input[i].checked = false;
        //     this.requestTracListSelected = false;
        //   }
        //   this.showAlert("error", "Please select the items from the same Location!");
        //   return
        // }
        this.assign_user = 'CHANGE ASSIGN'
        this.changeAssignmentPopup = true;
        this.change_assignment = [];
        this.number = 0;
        var dato = unique_array[0];
        this.dc_id = dato.toString()
        this.inv_id = this.selected.map(inventory => inventory.id);
        this.$httpSecured
          .get("/api/v1/warehouse/put_requests/location_users", { params: { distribution_center_id: this.dc_id } })
          .then(response => {
            if (response.data) {
              this.change_assignment_items = response.data.users;
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      makeLoadingFalse() {
        setTimeout(() => {
          this.loading = false;
        }, 1500);
      },
      handleFileChange(event) {
        const allowedExtensions = ["jpg", "jpeg", "png", "pdf"];
        
        if (!event.target.files.length) return;

        this.file = event.target.files[0];
        const fileName = this.file.name.toLowerCase();
        const fileExtension = fileName.split(".").pop();

        if (!allowedExtensions.includes(fileExtension)) {
          this.$toast.error("Allowed only: jpg, jpeg, png, pdf");
          this.file = null; 
          event.target.value = "";
        }
      },
      opencanceledtags() {
        this.canseledtagspopup = true;
      },
      cancelCansalation() {
        this.canseledtagspopup = false;
        this.tags = [],
          this.tags = JSON.parse(JSON.stringify(this.temp_cancelled_tag));
      },
      submitcansalation() {
        const temp_tags = this.tags.map(x => { const { tag_id, ...rest } = x; return rest; })
        for (var i = 0; i < this.tags.length; i++) {
          if (this.tags[i].tag_ids.length == 0) {
            this.tags[i].reject_reason = '';
          }
        }
        this.submittedTags = [].concat(...this.tags.map(person => person.tag_ids));
        this.temp_cancelled_tag = [];
        this.temp_cancelled_tag = JSON.parse(JSON.stringify((this.tags)));
        this.canseledtagspopup = false;
      },
      updatePendingDecisionSubmit() {
        this.number++;
        // const submittedTags = this.selected.map(item => item.id);
        const statement = this.submittedTags.map[
          {
            [this.reject_reason]: this.tag_ids
          }
        ];
        const selectedIds = this.selected.map(item => item.id);
        const temp_tags = this.tags.map(x => { const { tag_id, ...rest } = x; return rest; })
        const outwardReferenceValues = this.fields.map(field => field.outward_ref_value);
        const formData = new FormData();
        formData.append('handover_document', this.file);
        formData.append('ids', selectedIds);
        formData.append('outward_reference_document', this.outwordReferenceDocument);
        formData.append('outward_reference_value', outwardReferenceValues);
        formData.append('mode', parseInt(this.mode));
        if (this.logisticPartner != '') {
          formData.append('logistic_partner', parseInt(this.logisticPartner));
        }
        formData.append('vehicle_number', this.value_number);
        formData.append('dispatch_document_number', this.dispatch_document_number);
        if (this.submittedTags.length > 0) { formData.append('cancelled_items', JSON.stringify(temp_tags)) }

        this.$httpSecured.post("/api/v1/warehouse/dispatch/update_dispatch_details", formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then(response => {
            if (response.data) {
              this.okconfirmpopup = true;
              this.message = response.data.message;
              this.createUpdateDispatchDetails = false;
              this.loading = false;

            } else {
              this.ErroeMsg = response.data.error;
              // this.createUpdateDispatchDetails = false;
              this.loading = false;
              this.number = 0;
              this.$toast.error(this.ErroeMsg);
              // this.showAlert("error", errorMsg);
            }
          })
          .catch(error => {
            this.number = 0;
            this.$toast.error(error.response.data.error)
          })
      },

      // After Assignment of the assignee click confirm method in request tracker
      changeAssignConfirm() {
        this.number++;
        const formData = new FormData();
        this.$httpSecured.post("/api/v1/warehouse/put_requests/update_assignee", {
          "request_ids": this.inv_id,
          "assignee_ids": this.change_assignment
        },)
          .then(response => {
            if (response.data) {
              this.changeAssignmentPopup = false
              this.selected = []
              var input = document.querySelectorAll('.checkbox');
              for (var i = 0; i < input.length; i++) {
                input[i].checked = false;
                this.requestTracListSelected = false;
              }
              this.showAlert("success", "Successfully updated");
              this.loadData(this.active_tab);
            } else {
              // this.showAlert("error", "No Data Found");
              this.number = 0;
              this.$toast.error("No Data Found");
            }
          }).catch(error => {
            this.number = 0;
            // this.showAlert("error", "Something went wrong from Network");
            this.$toast.error(error.response.data.error)
            this.loading = false;
          });
      },

      // change assesment in edit request inside Request-tracker tab
      changeAssignmentEditFunc() {
        this.number = 0;
        this.changeAssignmentEditPopup = true
        var dc = this.selected.map(x => x.distribution_center_id)
        const unique = (value, index, self) => {
          return self.indexOf(value) === index
        }
        dc = dc.filter(function (element) {
          return element !== undefined;
        });

        var unique_array = dc.filter(unique)
        var dato = unique_array[0];
        this.dc_id = dato.toString()
        this.$httpSecured
          .get("/api/v1/warehouse/put_requests/location_users", { params: { distribution_center_id: this.dc_id } })
          .then(response => {
            if (response.data) {
              this.change_assignment_edit_items = response.data.users;
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },

      // Assigning Dispositions menu in Pending Disposition Screen
      assignDispositionList() {
        this.$httpSecured
          .get("/api/v1/warehouse/dispatch/get_dispositions")
          .then(response => {
            if (response.data) {
              this.assign_disposition_list = response.data.dispositions;
              // this.makeLoadingFalse();
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },

      // post method to send disposition after selecting
      assignDisposition(item) {
        this.selectedDisposition = item.id;
        this.dispatch_id = this.selected.map(warehouse_order_items => warehouse_order_items.id)
        const dispatchDetails = {
          "ids": this.dispatch_id,
          "disposition": this.selectedDisposition,
        }
        this.$httpSecured
          .post("/api/v1/warehouse/dispatch/set_disposition", dispatchDetails)
          .then(response => {
            if (response.data) {
              this.message = response.data.message
              this.okconfirmpopup = true,
                this.selectedDisposition = "",
                this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          })
      },

      updateSubLocationDialog() {
        if (this.selected.length <= 0) {
          this.showAlert('warning', 'Please Select Item First')
          return
        }

        var dc = this.selected.map(x => x.distribution_center_id)
        const unique = (value, index, self) => {
          return self.indexOf(value) === index
        }
        dc = dc.filter(function (element) {
          return element !== undefined;
        });

        var unique_array = dc.filter(unique)
        // if (unique_array.length > 1){
        //   this.selected = []
        //   var input = document.querySelectorAll('.checkbox');
        //   for (var i = 0; i < input.length; i++) {
        //     input[i].checked = false;
        //     this.openListSelected = false;
        //   }
        //   this.showAlert("error", "Please select the items from the same Location!");
        //   return
        // }
        this.updateSubLocation = true;
        this.number = 0;
        this.sub_location = '';
        var dato = unique_array[0];
        this.dc_id = dato.toString()
        this.inv_id = this.selected.map(inventory => inventory.id);
        this.$httpSecured
          .get("/api/v1/warehouse/put_away/sub_locations", { params: { distribution_center_id: this.dc_id } })
          .then(response => {
            if (response.data) {
              this.update_sub_location = response.data.sub_locations;
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },


      //  Update sub-location submit in not-found-items tab
      updateSubLocSubmit() {
        this.number++;
        const formData = new FormData();
        this.$httpSecured.put("/api/v1/warehouse/dispatch/update_sub_location", {
          "ids": this.inv_id,
          "sub_location_id": this.sub_location
        },)
          .then(response => {
            if (response.data) {
              this.updateSubLocation = false
              this.okconfirmpopup = true
              this.selected = []
              var input = document.querySelectorAll('.checkbox');
              for (var i = 0; i < input.length; i++) {
                input[i].checked = false;
              }
              this.showAlert("success", "Successfully updated");
              this.loadData(this.active_tab);
            } else {
              // this.showAlert("error", "No Data Found");
              this.number = 0;
              this.$toast.error("No Data Found");
            }
          }).catch(error => {
            this.number = 0;
            this.$toast.error(error.response.data.error);
            // this.showAlert("error", "Something went wrong from Network");
            this.loading = false;

          });

      },

      // WriteOffItem function
      // writeOffItem(){
      //      var dc = this.selected.map(x => x.distribution_center_id)
      // const unique = (value, index, self) => {
      //   return self.indexOf(value) === index
      // }
      // dc = dc.filter(function (element) {
      //   return element !== undefined;
      // });

      // var unique_array = dc.filter(unique)
      // if (unique_array.length > 1) {
      //   this.selected = []
      //   var input = document.querySelectorAll('.checkbox');
      //   for (var i = 0; i < input.length; i++) {
      //     input[i].checked = false;
      //     this.inwardSelected = false;
      //   }
      //   this.showAlert("error", "Please select the items from the same Location!");
      //   return
      // }
      // this.writeOffItemDialog = true;
      // this.selected_headers = [
      //   {
      //     title: "Tag/BoxID",
      //     value: "tag_number",
      //     align: "start",
      //     sortable: false,
      //     width: "12%"
      //   },
      //   { title: "Last Sub-Location", value: "sub_location" },
      //   { title: "Category", value: "category" },
      //   { title: "Article ID", value: "sku_code" },
      //   { title: "Article Description", value: "item_description" },
      // ];
      // this.selected_table_data = this.selected;
      // this.inv_id = this.selected.map(inventory => inventory.id);
      // var dato = unique_array[0];
      // this.dc_id = dato.toString()
      // },

      // Raise Debit Note Popup
      raiseDebitNote() {
        this.number = 0;
        this.raiseDebitNotePopup = true;
      },
      // close success popup
      closemsg() {
        this.assignExecutivePopup_2 = false;
        this.successDialogInward = false;
        this.createPendingpackaging = false;
        this.assignTo = '';
        this.loadData(this.active_tab);
      },
      // Raise-debit-note submit function Api call
      raiseDebitNoteSubmit() {
        this.number++;
        var dc = this.selected.map(x => x.id)
        const formData = new FormData();
        formData.append("raised_against", this.raise_note_against)
        formData.append("debit_amount", this.debit_amount)
        this.$httpSecured
          .put("/api/v1/warehouse/dispatch/" + dc + "/write_off", formData)
          .then(response => {
            if (response.data) {
              this.update_sub_location_open = response.data.sub_locations;
              this.loading = false;
              this.raiseDebitNotePopup = false;
              this.raise_note_against = "";
              this.debit_amount = "";
              this.showAlert("success", "Successfully updated");
              this.loadData(this.active_tab);
            } else {
              this.loading = false;
              this.number = 0;
              this.$toast.error("No Data Found");
              // this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.number = 0;
            this.$toast.error(error.response.data.message)
            this.loading = false;
          });
      },

      //  after click ok load the table data
      afterClickOkLoadData() {
        this.okconfirmpopup = false;
        this.rejectsussesspopup = false;
        if (this.deleting_box_items) {
          this.deleting_box_items = false;
          this.detailDataPopup = false;
          this.box_items_list = [];
          this.box_items_selected = [];
        }
        this.loadData(this.active_tab);
      },


      Loadfilterdata() {
        this.$httpSecured
          .get('/api/v1/warehouse/dispatch/get_filters_data')
          .then(response => {
            if (response.data) {
              this.pickup_request_status = response.data.request_statuses;
              this.disposition_filter_items = response.data.dispositions
              this.packaging_request_status = response.data.request_statuses;
              // this.makeLoadingFalse();
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.$toast.error(error.response.data.error)
            this.loading = false;
          })
      },
      // Apply Filters Function
      applyFilterFunc() {
        this.dispatch_search = '';
        const params = new URLSearchParams();

        const pageparams = this.getRequestParams(
          this.page,
          this.pageSize
        );
        params.append('page', pageparams['page'])
        params.append('per_page', pageparams['size'])
        if (this.active_tab == "Pending Pick-Up") {
          const selectedStatusIds = this.filterPickupRequestStatus ? this.filterPickupRequestStatus.id : '' || "";
          if (selectedStatusIds !== undefined) {
            params.append('request_status', selectedStatusIds);
          }
          params.append('lot_name', this.lot_name_search);
          params.append('outward_reason_ref_order', this.outward_reason_ref_search);
          params.append('destination_type', this.destination_type_search);
          params.append('request_status', selectedStatusIds);
          params.append('tab', 'pending_pickup');
          params.append('disposition', this.disposition_filter ? this.disposition_filter : "")
          this.$httpSecured
            .get('/api/v1/warehouse/dispatch/fetch_orders', { params })
            .then(response => {
              if (response.data) {
                this.table_data = response.data.warehouse_order_items
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count
                this.filteWithSubPopup = false;
                this.loading = false;
                this.selected = [];
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");

              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
        } else if (this.active_tab == "Pending Packaging") {
            const selectedStatusIds = this.filterPackagingRequestStatus ? this.filterPackagingRequestStatus.id : '' || "";
            params.append('lot_name', this.lot_name_search);
            params.append('outward_reason_ref_order', this.outward_reason_ref_search);
            params.append('destination_type', this.destination_type_search);
            params.append('request_status', selectedStatusIds);
            params.append('tab', 'pending_packaging');
            params.append('disposition', this.disposition_filter ? this.disposition_filter : "")
            this.$httpSecured
              .get('/api/v1/warehouse/dispatch/fetch_orders', { params })
              .then(response => {
                if (response.data) {
                  this.table_data = response.data.warehouse_order_items
                  this.totalPages = response.data.meta.total_pages;
                  this.totalCount = response.data.meta.total_count
                  this.filteWithSubPopup = false;
                  this.lot_name = '';
                  this.outward_reason_ref = '';
                  this.destination_type = '';
                  this.filterPackagingRequestStatus = '';
                  this.loading = false;
                  this.selected = [];
                } else {
                  this.loading = false;
                  this.showAlert("error", "No Data Found");

                }
              })
              .catch(error => {
                this.showAlert("error", "Something went wrong from Network" + error);
                this.loading = false;
              });
          } else
            if (this.active_tab == "Pending Dispatch") {
              const selectedStatusIds = this.destination_items ? this.destination_items.id : '' || "";
              params.append('box_number', this.box_id_search);
              params.append('outward_reason_ref_order', this.outward_reason_ref_search);
              params.append('destination_type', this.destination_type_search);
              params.append('destination', this.destination_items);
              params.append('tab', 'pending_dispatch');
              params.append('disposition', this.disposition_filter ? this.disposition_filter : "")
              this.$httpSecured
                .get('/api/v1/warehouse/dispatch/dispatch_boxes', { params })
                .then(response => {
                  if (response.data) {
                    this.table_data = response.data.dispatch_boxes
                    this.totalPages = response.data.meta.total_pages;
                    this.totalCount = response.data.meta.total_count
                    this.filteWithSubPopup = false;
                    this.lot_name = '';
                    this.outward_reason_ref = '';
                    this.destination_type = '';
                    this.filterPickupRequestStatus = '';
                    this.loading = false;
                    this.selected = [];
                  } else {
                    this.loading = false;
                    this.showAlert("error", "No Data Found");

                  }
                })
                .catch(error => {
                  this.showAlert("error", "Something went wrong from Network" + error);
                  this.loading = false;
                });
            } else
              if (this.active_tab == "Request Tracker") {
                const requestTypeIds = this.request_type_search ? this.request_type_search.id : '' || "";
                const statusids = this.status_search ? this.status_search.id : '' || "";
                params.append('dispatch_requests', true);
                params.append('request_type', requestTypeIds);
                params.append('status', statusids);


                this.$httpSecured
                  .get('/api/v1/warehouse/put_requests', { params })
                  .then(response => {
                    if (response.data) {
                      this.table_data = response.data.put_requests
                      this.totalPages = response.data.meta.total_pages;
                      this.totalCount = response.data.meta.total_count
                      this.filteWithSubPopup = false;
                      this.request_type_search = '';
                      this.status_search = '';
                      this.loading = false;
                      this.selected = [];

                    } else {
                      this.loading = false;
                      this.showAlert("error", "No Data Found");

                    }
                  })
                  .catch(error => {
                    this.showAlert("error", "Something went wrong from Network" + error);
                    this.loading = false;
                  });
              } else
                if (this.active_tab == "Pending Disposition") {
                  const rejectSearchIds = this.reason_for_reject_search ? this.reason_for_reject_search.id : '' || ""
                  params.append('tab', 'pending_disposition');
                  params.append('sku_code', this.article_id_search);
                  params.append('reject_reason', rejectSearchIds);

                  this.$httpSecured
                    .get('/api/v1/warehouse/dispatch/fetch_orders', { params })
                    .then(response => {
                      if (response.data) {
                        this.table_data = response.data.warehouse_order_items
                        this.totalPages = response.data.meta.total_pages;
                        this.totalCount = response.data.meta.total_count
                        this.filteWithSubPopup = false;
                        this.reason_for_reject_search = '';
                        this.article_id_search = '';
                        this.rejectSearchIds = '';
                        this.loading = false;
                        this.selected = [];
                      } else {
                        this.loading = false;
                        this.showAlert("error", "No Data Found");

                      }
                    })
                    .catch(error => {
                      this.showAlert("error", "Something went wrong from Network" + error);
                      this.loading = false;
                    });
                } else
                  if (this.active_tab == "Not Found Items") {
                    params.append('tab', 'not_found_items')
                    params.append('sku_code', this.article_id_notfound_search);
                    params.append('category', JSON.stringify(this.category_search.map(item => item.key)));

                    this.$httpSecured
                      .get('/api/v1/warehouse/dispatch/fetch_orders', { params })
                      .then(response => {
                        if (response.data) {
                          this.table_data = response.data.warehouse_order_items
                          this.totalPages = response.data.meta.total_pages;
                          this.totalCount = response.data.meta.total_count
                          this.filteWithSubPopup = false;
                          this.article_id_notfound_search = '';
                          this.category_search = [];
                          this.loading = false;
                          this.selected = [];
                        } else {
                          this.loading = false;
                          this.showAlert("error", "No Data Found");

                        }
                      })
                      .catch(error => {
                        this.showAlert("error", "Something went wrong from Network" + error);
                        this.loading = false;
                      });
                  }
      },

      assignExecutiveFnc() {
        this.number = 0;
        this.assignExecutivePopup = true;
        this.request_type = 'packaging'
        this.assignee_ids = ''
        // this.requestReason = ''
        this.assignTo = null;
        var dc = this.selected.map(x => x.distribution_center_id)
        const unique = (value, index, self) => {
          return self.indexOf(value) === index
        }
        dc = dc.filter(function (element) {
          return element !== undefined;
        });

        var unique_array = dc.filter(unique)
        var dato = unique_array[0];
        this.dc_id = dato.toString()
        let status_value = ''
        if(this.active_tab === 'Pending Pick-Up'){
           status_value = 'pending_pick'
        }
        this.$httpSecured
          .get("/api/v1/warehouse/put_requests/location_users", { params: { distribution_center_id: this.dc_id, status: status_value } })
          .then(response => {
            if (response.data) {
              this.request_type = response.data.put_request;
              this.assignee_ids = response.data.users
              this.$nextTick(() => {
                if (this.request_type === 'packaging') {
                  // this.requestReason = ''
                  this.assignTo = ''
                  this.assignExecutivePopup = true;
                }
              }),
                this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      assignExecutiveSubmit() {
        this.number++;
        const formData = new FormData();

        this.$httpSecured.post("api/v1/warehouse/dispatch/create_pick_up_request", {
          put_request:
          {
            "request_type": "packaging",
            "distribution_center_id": this.dc_id,
            "pick_up_reason": "packaging",
            "assignee_ids": this.assignTo,
            "inventory_ids": this.inv_id,
            "sub_location": this.sub_location
          }
        },)
          .then(response => {
            if (response.data) {
              this.selctedItemsPopup = false;
              this.assignExecutivePopup = false;
              this.temp_selectedData = this.selected;
              this.selected = []
              var input = document.querySelectorAll('.checkbox');
              for (var i = 0; i < input.length; i++) {
                input[i].checked = false;
                this.inwardSelected = false;
              }
              this.successDialogInward = true;
              this.returnId = response.data.put_request.request_id;
              this.successMsg = response.data.message;
              this.loadData(this.active_tab);
              this.showAlert("success", "Successfully request created");
              this.loadData(this.active_tab);
            } else {
              // this.assignExecutivePopup = false
              this.number = 0;
              this.$toast.error("No Data Found");
              // this.showAlert("error", "No Data Found");
            }
          }).catch(error => {
            this.number = 0;
            // this.showAlert("error", "Something went wrong from Network");
            this.$toast.error(error.response.data.error)
            this.loading = false;
          });
      },
      assignExecutiveSubmit_2() {
        this.number++;
        const formData = new FormData();

        this.$httpSecured.post("/api/v1/warehouse/dispatch/create_packaging_request", {
          put_request:
          {
            "request_type": "packaging",
            "distribution_center_id": this.dc_id,
            "pick_up_reason": "packaging",
            "assignee_ids": this.assignTo,
            "inventory_ids": this.inv_id,
            "sub_location": this.sub_location
          }
        },)
          .then(response => {
            if (response.data) {
              this.selctedItemsPopup = false;
              this.assignExecutivePopup = false;
              this.temp_selectedData = this.selected;
              this.selected = []
              var input = document.querySelectorAll('.checkbox');
              for (var i = 0; i < input.length; i++) {
                input[i].checked = false;
                this.inwardSelected = false;
              }
              this.successDialogInward = true;
              this.returnId = response.data.put_request.request_id;
              this.successMsg = response.data.message;
              this.loadData(this.active_tab);
              this.showAlert("success", "Successfully request created");
              this.loadData(this.active_tab);
            } else {
              // this.assignExecutivePopup = false
              this.number = 0;
              this.$toast.error("No Data Found");
              // this.showAlert("error", "No Data Found");
            }
          }).catch(error => {
            this.number = 0;
            this.$toast.error(error.response.data.error);
            // this.showAlert("error", "Something went wrong from Network");
            this.loading = false;
          });
      },
      showErrorPopup(errorMessage) {
        this.errorDialog = true;
        this.errorMsg = errorMessage;
      },
      openDataDetails(item, tab) {
        this.detailDataPopup = true;
        if (tab == 'requestTracker') {
          this.reqst_Id = item.request_id;
          this.rqustType = item.request_type;
          this.distribCenter = item.distribution_center;
          this.assignedTo = item.assignee_name;
          this.status1 = item.status;
        }
        else {
          this.bx_Id = item.box_number;
          this.orrdNumber = item.orrd;
          this.destType = item.destination_type;
          this.dest = item.destination;
          this.fetchBoxItems(item.id);
        }
      },
      fetchBoxItems(dispatchBoxId) {
        this.box_items_loading = true;
        this.box_items_list = [];
        this.box_items_selected = [];
        this.$httpSecured
          .get('/api/v1/warehouse/dispatch/box_items', { params: { dispatch_box_id: dispatchBoxId } })
          .then(response => {
            this.box_items_list = response.data.items || [];
            this.box_items_loading = false;
          })
          .catch(error => {
            this.box_items_loading = false;
            this.showAlert("error", "Something went wrong from Network" + error);
          });
      },
      createUpdateDetails() {
        this.destination_type = this.selected[0].destination_type;
        this.destination = this.selected[0].destination;
        const selectedMode = this.mode_items.find(item => {
          return this.selected[0].mode && item.name.toLowerCase() === this.selected[0].mode.toLowerCase();
        });
        this.mode = selectedMode ? selectedMode.id : '';
        this.dispatch_document_number = this.selected[0].dispatch_document_number || '';
        this.fields = [{
        outward_ref_value: (this.selected[0].outward_reference_value !== null && this.selected[0].outward_reference_value !== undefined)
          ? String(this.selected[0].outward_reference_value)
          : ''
        }];
        this.value_number = this.selected[0].vehicle_number || '';

        const ord_list = this.selected.map(item => item.orrd);
        const temp_var = Array.from(new Set(ord_list));
        if (temp_var.length > 1) {
          this.showAlert("warning", "ORRD should be same for selected boxes!");
          this.selected = [];
          return;
        } else {
          this.outwordReferenceDocument = this.selected[0].or_document;
          this.intial_value = this.outwordReferenceDocument;
        }
        // this.outward_ref_item = '';
        // this.outward_ref_value = '';
        // this.mode_items = '';
        // this.outwordReferenceDocument = '';

        this.modeDisabled = !!this.selected[0].mode;  // Disable if mode is present
        this.dispatchDocumentDisabled = !this.selected[0].disable_stn || !!this.selected[0].dispatch_document_number;  // Disable if dispatch document number is present
        this.vehicleDisabled = !!this.selected[0].vehicle_number;  // Disable if vehicle number is present
        this.outwardDisabled = !!this.selected[0].outward_reference_value;  // Disable if outward reference value is present
        
        this.showError = false;
        // this.mode = null;
        this.logisticPartner = null;
        // this.value_number = '';
        // this.dispatch_document_number = '';
        this.file = '';
        this.tags = [{ reject_reason: null, tag_ids: [] }],
          this.temp_cancelled_tag = this.tags;
        this.createUpdateDispatchDetails = true;
        this.number = 0;
        this.submittedTags = [];
        // this.fields = [{ outward_ref_value: '' }];
      },
      fetchDocumentRefernce() {
        this.$httpSecured
          .get("/api/v1/warehouse/dispatch/get_filters_data")
          .then(response => {
            if (response.data) {
              this.outward_ref_item = response.data.outward_ref_documents;
              this.mode_items = response.data.modes;
              this.logistic_partner_items = response.data.logistic_partners;
              // this.loading = false;
            } else {
              // this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            // this.loading = false;
          });
      },
      assignExecutiveFnc_2() {
        this.number = 0;
        this.assignExecutivePopup_2 = true;
        this.assignee_ids = '';
        this.assignTo = null;
        var dc = this.selected.map(x => x.distribution_center_id)
        const unique = (value, index, self) => {
          return self.indexOf(value) === index
        }
        dc = dc.filter(function (element) {
          return element !== undefined;
        });

        var unique_array = dc.filter(unique)
        var dato = unique_array[0];
        this.dc_id = dato.toString()
        this.$httpSecured
          .get("/api/v1/warehouse/put_requests/location_users", { params: { distribution_center_id: this.dc_id, status:'pending_pack'  } })
          .then(response => {
            if (response.data) {
              this.assignee_ids = response.data.users
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      createRequestPopup() {
        var dc = this.selected.map(x => x.distribution_center_id)
        const unique = (value, index, self) => {
          return self.indexOf(value) === index
        }
        dc = dc.filter(function (element) {
          return element !== undefined;
        });

        var unique_array = dc.filter(unique)
        // if (unique_array.length > 1) {
        //   this.selected = []
        //   var input = document.querySelectorAll('.checkbox');
        //   for (var i = 0; i < input.length; i++) {
        //     input[i].checked = false;
        //     this.inwardSelected = false;
        //   }
        //   this.showAlert("error", "Please select the items from the same Location!");
        //   return
        // }

        const centerId = this.selected.map(item => item.distribution_center_id)
        const centerList = Array.from(new Set(centerId));
        if (centerList.length > 1) {
          this.showAlert("warning", "Please select the items from same location!");
          this.selected = []
          return;
        }
        var hasBlankSubLocation = this.selected.some(item => !item.sub_location);
        if (hasBlankSubLocation) {
          this.showAlert("error", "sub location can't be blank");
          this.selected = []
          return;
        }
        var hasPendingRequest = this.selected.some(item => item.pickup_request_status === "Pending");
        if (hasPendingRequest) {
          this.showAlert("warning", "Request already Created");
          this.selected = []
          return;
        }
        const dest_list = this.selected.map(x => x.destination_type);
        const temp_var = Array.from(new Set(dest_list));
        if (temp_var.length > 1) {
          this.showAlert("warning", "Please select the items from the same Destination Type!");
          this.selected = []
          return;
        }

        const orrdList = this.selected.map(x => x.outward_reason_ref_order);
        const temp_orrd = Array.from(new Set(orrdList));
        if (temp_orrd.length > 1) {
          this.showAlert("warning", "Please select the items from the same Outward Reason Ref Order!");
          this.selected = []
          return;
        }
        this.selctedItemsPopup = true;
        this.selected_headers = [
          { title: "Tag ID", key: "tag_number", align: "start", sortable: false, width: "12%" },
          { title: "Lot ID", key: "lot_id" },
          { title: "Lot Name", key: "lot_name" },
          { title: "Outward Reason Ref Order", key: "outward_reason_ref_order" },
          { title: "Destination Type", key: "destination_type" },
          { title: "Pick Up Request Status", key: "pickup_request_status" },
          { title: 'Delete', key: 'action' }
        ];
        this.selected_table_data = this.selected;
        this.totalItemCount = this.selected.length
        this.item = 1
        this.inv_id = this.selected.map(inventory => inventory.id);
        var dato = unique_array[0];
        this.dc_id = dato.toString()
      },
      createPickuppopup() {
        // var hasBlankSubLocation = this.selected.some(item => !item.sub_location);
        // if (hasBlankSubLocation) {
        //   this.showAlert("error", "sub location can't be blank");
        //   this.selected = []
        //   return;
        // }
        var hasPendingRequest = this.selected.some(item => item.pickup_request_status === "Pending");
        if (hasPendingRequest) {
          this.showAlert("warning", "Request already Created");
          this.selected = []
          return;
        }
        const orrdList = this.selected.map(x => x.outward_reason_ref_order);
        const temp_orrd = Array.from(new Set(orrdList));
        if (temp_orrd.length > 1) {
          this.showAlert("warning", "Please select the items from the same Outward Reason Ref Order!");
          this.selected = []
          return;
        }
        const centerId = this.selected.map(item => item.distribution_center_id)
        const temp_var = Array.from(new Set(centerId));
        if (temp_var.length > 1) {
          this.showAlert("warning", "Please select the items from same location!");
          this.selected = []
          return;
        }
        this.createPendingpackaging = true;
        this.selected_headers = [
          { title: "Tag ID", key: "tag_number", align: "start", sortable: false, width: "12%" },
          { title: "Lot ID", key: "lot_id" },
          { title: "Lot Name", key: "lot_name" },
          { title: "Outward Reason Ref Order", key: "outward_reason_ref_order" },
          { title: "Destination Type", key: "destination_type" },
          { title: "Packaging Request Status", key: "pickup_request_status" },
          { title: 'Delete', key: 'action' }
        ];
        this.selected_table_data = this.selected;
        this.totalItemCount = this.selected.length
        this.item = 1
        this.inv_id = this.selected.map(inventory => inventory.id);
        let dc = this.selected.map(x => x.distribution_center_id)
        const unique = (value, index, self) => {
          return self.indexOf(value) === index
        }
        dc = dc.filter(function (element) {
          return element !== undefined;
        });
        var unique_array = dc.filter(unique)
        var dato = unique_array[0];
        this.dc_id = dato.toString()
      },
      showAlert(alert_type, alert_message) {
        this.scrollToTop();
        this.alert = true;
        this.alert_type = alert_type;
        this.alert_message = alert_message;
        this.alertTimeOut();
      },
      linkPopupInReqTracker(item) {
        this.datadetailpopupdisposition = true;
        this.tag_number = String(item.tag_number);
        this.sku_master_code = String(item.sku_master_code);
        this.item_description = String(item.item_description);
        this.lot_id = String(item.lot_id);
        this.lot_name = String(item.lot_name);
        this.destination_type = String(item.destination_type);
        this.outward_reason_ref_order = String(item.outward_reason_ref_order);
        this.pickup_request_status = String(item.pickup_request_status);
        this.sub_location = String(item.sub_location);
      },
      alertTimeOut() {
        setTimeout(() => {
          this.alert = false;
        }, 3000);
      },
      handlePageSizeChange(size) {
        this.pageSize = size;
        this.page = 1
        if(this.applied_filter){
          this.applyFilterFunc();
        }else{
          if (this.active_tab == 'Pending Pick-Up') { this.PendingPickUP(); }        
        else if (this.active_tab == 'Pending Packaging') { this.PendingPackaging(); }
        else if (this.active_tab == 'Pending Dispatch') { this.PendingDispatch(); }
        else if (this.active_tab == 'Request Tracker') { this.fetchRequestTracker(); }
        else if (this.active_tab == 'Pending Disposition') { this.fetchPendingDisposition(); }
        else if (this.active_tab == 'Not Found Items') { this.fetchNotFoundItems(); }
        }
      },
      handlePageChange(value) {
        this.page = value;
        if(this.applied_filter === true){
          this.applyFilterFunc();
        }else{
         if (this.active_tab == 'Pending Pick-Up') { this.PendingPickUP(); }
          else if (this.active_tab == 'Pending Packaging') { this.PendingPackaging(); }
          else if (this.active_tab == 'Pending Dispatch') { this.PendingDispatch(); }
          else if (this.active_tab == 'Request Tracker') { this.fetchRequestTracker(); }
          else if (this.active_tab == 'Pending Disposition') { this.fetchPendingDisposition(); }
          else if (this.active_tab == 'Not Found Items') { this.fetchNotFoundItems(); }
        }
      },
      handleItemChange(value) {
        this.item = value;
        // if(this.selctedItemsPopup == true){
        //   this.createRequestPopup()
        // }else if(this.createPendingpackaging == true){
        //   this.createPickuppopup();
        // }
      },
      //  To handle the page size change
      handleItemSizeChange(size) {
        this.itemSize = size;
        this.item = 1
        // if(this.selctedItemsPopup == true){
        //   this.createRequestPopup()
        // }else if(this.createPendingpackaging == true){
        //   this.createPickuppopup();
        // }
      },
      // pagination params
      getRequestParams(page, pageSize) {
        let params = {};
        if (page) {
          params["page"] = page;
        }
        if (pageSize) {
          params["size"] = pageSize;
        }
        return params;
      },

      selectAll() {
        if (this.active_tab == 'Request Tracker') {
          this.change_assignment = this.change_assignment_items.map((user) => user.id);
        }
      },
      selectAllEditItem() {
        this.change_assignment_item_edit = this.change_assignment_edit_items.map((user) => user.id);
      },

      //  cancel request in Request-tracker tab
      cancelRequestDialogOpen() {
        this.cancelRequestPopup = true;
      },

      //  cancel request sublit in Request-tracker tab
      cancelRequestSubmit() {
        this.$httpSecured.post("api/v1/warehouse/put_requests/cancel_request", {

          "request_ids": this.selected.map(x => x.id)

        })
          .then(response => {
            if (response.data) {
              this.cancelRequestPopup = false;
              this.cancelSuccesPopup = true;
              this.temp_selectedData = this.selected;
              var input = document.querySelectorAll('.checkbox');
              for (var i = 0; i < input.length; i++) {
                input[i].checked = false;
                this.requestTracListSelected = false;
              }
              this.showAlert("success", "Requests cancelled successfully");
              this.loadData(this.active_tab);
              this.active_tab == 'Request Tracker'
            } else {
              this.showAlert("error", "No Data Found");
            }
          }).catch(error => {
            this.showAlert("error", "Something went wrong from Network");
            this.loading = false;
          });
      },

      addMoreItems() {
        this.writeOffItemDialog = false;
      },

      // Delete in Edit Request in Request-tracker
      // deleteReqTracker(){
      //   this.selected.forEach(item => {
      //   const index = this.edit_req_table_data.indexOf(item);
      //   if (index !== -1) {
      //     this.edit_req_table_data.splice(index, 1);
      //   }
      // });
      // this.selected = [];
      // },

      deleteEvenTrack(item) {
        const index = this.edit_req_table_data.indexOf(item);
        if (index !== -1) {
          this.edit_req_table_data.splice(index, 1);
        }
      },

      deleteEvent(item) {
        if (this.active_tab == 'Pending Pick-Up') {
          const index = this.selected_table_data.indexOf(item);
          this.selected_table_data.splice(index, 1);
          this.inv_id = this.selected_table_data.map(x => x.id)
          if (this.selected_table_data.length == 0) {
            this.selected_table_data = []
            this.selctedItemsPopup = false;
            this.loadData(this.active_tab)
            var input = document.querySelectorAll('.checkbox');
            for (var i = 0; i < input.length; i++) {
              input[i].checked = false;
              this.selctedItemsPopup = false;
            }
          }
        } else if (this.active_tab == 'Pending Packaging') {
          const index = this.selected_table_data.indexOf(item);
          this.selected_table_data.splice(index, 1);
          this.inv_id = this.selected_table_data.map(x => x.id)
          if (this.selected_table_data.length == 0) {
            this.selected_table_data = []
            this.createPendingpackaging = false;
            this.loadData(this.active_tab)
            var input = document.querySelectorAll('.checkbox');
            for (var i = 0; i < input.length; i++) {
              input[i].checked = false;
              this.createPendingpackaging = false;
            }
          }
        } else if (this.active_tab == 'Not Found Items') {
          const index = this.selected_table_data.indexOf(item);
          this.selected_table_data.splice(index, 1);
          this.inv_id = this.selected_table_data.map(x => x.id)
          if (this.selected_table_data.length == 0) {
            this.selected_table_data = []
            this.writeOffItemDialog = false;
            this.loadData(this.active_tab)
            var input = document.querySelectorAll('.checkbox');
            for (var i = 0; i < input.length; i++) {
              input[i].checked = false;
              this.writeOffItemDialog = false;
            }
          }
        }

      },

      // closing debit note function
      raiseDebitNoteClose() {
        this.raise_note_against = "";
        this.debit_amount = "";
      },

      // filter popup clear fields when closed
      filterPopupClose() {
        this.request_type_search = '';
        this.status_search = '';
      },

      // close popup of update-dispatch-details in pending dispatch
      closeUpdateDispatchDetails() {
        this.createUpdateDispatchDetails = false;
        this.outwordReferenceDocument = [];
        this.fields = [
          { outward_ref_value: '' } // Initial field
        ]
        this.mode = [];
        this.logisticPartner = '';
        this.value_number = [];
        this.dispatch_document_number = [];
        this.file = '';
      },
      updateOtherDetail() {
        this.logisticPartner = '';
        this.value_number = '';
        this.dispatch_document_number = '';
      },
      downloadFile(value) { 
        this.number++;
        const formData = new FormData();
        if(value === 'submit'){
          formData.append('email_ids', this.email_id);
        }else{
        const ids = this.selected.map(item => item.id);
        ids.forEach(id => formData.append('ids[]', id));
      }
        this.$httpSecured
        .post("/api/v1/warehouse/dispatch/download_pending_dispatch_items", formData)
          .then(response => {
              if (response.data) {
                if(value === 'submit'){
               this.snackbar = true;
               this.downloadDialog = false;
               this.email_id='';
              this.snackbar = {
                    color: "success",
                    icon: "mdi-check-circle",
                    mode: "multi-line",
                    position: "top",
                    timeout: 3000,
                    title: 'Success',
                    text: response.data.message,
                    visible: true
                  };
            }else{
             const url = response.data.url;
              const link = document.createElement('a');
              link.href = url;
              link.download = '';
              document.body.appendChild(link);
              link.click();
              this.snackbar = {
                color: "success",
                icon: "mdi-check-circle",
                mode: "multi-line",
                position: "top",
                timeout: 3000,
                title: "Success",
                text: "(CSV File) Downloaded Successfully",
                visible: true
              };
            }
              this.selected = [];
              this.number = 0;
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
                this.number = 0;
              }
          })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
          this.number = 0;
        });
      },
      navigateToFileUpload() {
        this.$store.commit("setLotIds", {
          lotIds: this.headerText,
          inventoryId: "Pending Dispatch",
          action:'second_tab'
        });        
        this.$router.push({ name: "LotFileuploadComm" });
      },
      validateEmail() {
        const emails = this.email_id.split(',').map(email => email.trim());
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emails.length === 1 && !emailPattern.test(emails[0])) {
          this.emailError = 'Please enter a valid email';
          this.isEmailValid = false
          return;
        }else{
          this.isEmailValid = true
        }
        for (const email of emails) {
          if (!emailPattern.test(email)) {
            this.emailError = 'Please enter valid email ids separated by commas';
            this.isEmailValid = false
            return;
          }else{
            this.isEmailValid = true
          }
        }     
        this.emailError = null;
      },
   openPopup(){
        this.downloadDialog = true;
        this.email_id = this.$store.state.currentUser.email;
        this.validateEmail(this.email_id)
      },
      deleteORRD(){
          this.deleting_box_items = false;
          const ids = this.selected.map(item => item.id);
          if(this.active_tab === 'Pending Dispatch'){
             this.orrd_number = Array.from(
            new Set(this.selected.map(item => item.orrd))
          ).join(", ");
          }else{
            this.orrd_number = Array.from(
            new Set(this.selected.map(item => item.outward_reason_ref_order))
          ).join(", ");
          }
           if(this.active_tab === 'Pending Pick-Up')
              this.tab_name = 'pending_pick';
            else if(this.active_tab === 'Pending Packaging')
             this.tab_name = 'pending_pack';
            else
            this.tab_name = 'pending_dispatch';       

          this.$httpSecured
          .post("/api/v1/warehouse/dispatch/validate_delete_orrd_items", 
              {
                  "ids":ids,
                  "tab_status": this.tab_name
              }
          )
          .then(response => {
            if (response.data) {
              this.ORRD_delete_confirmation = true;
              this.successmessage = response.data.message;
            } else {
              this.showAlert("error", "No Data Found");
            }
          }).catch(error => {
                // this.showAlert("error", error.response.data.error);
                this.snackbar = {
                color: "error",
                icon: "mdi-check-circle",
                mode: "multi-line",
                position: "top",
                timeout: 3000,
                title: "Success",
                text: error.response.data.error,
                visible: true
              };
            });          
        },
        deleteBoxItemsORRD(){
          const ids = this.box_items_selected.map(item => item.id);
          this.orrd_number = Array.from(
            new Set(this.box_items_selected.map(item => item.orrd))
          ).join(", ");
          this.tab_name = 'pending_dispatch_item';
          this.deleting_box_items = true;

          this.$httpSecured
          .post("/api/v1/warehouse/dispatch/validate_delete_orrd_items",
              {
                  "ids":ids,
                  "tab_status": this.tab_name
              }
          )
          .then(response => {
            if (response.data) {
              this.ORRD_delete_confirmation = true;
              this.successmessage = response.data.message;
            } else {
              this.showAlert("error", "No Data Found");
            }
          }).catch(error => {
                this.snackbar = {
                color: "error",
                icon: "mdi-check-circle",
                mode: "multi-line",
                position: "top",
                timeout: 3000,
                title: "Success",
                text: error.response.data.error,
                visible: true
              };
            });
        },
        deleteORRDAfterConfirm(){
          const ids = this.deleting_box_items
            ? this.box_items_selected.map(item => item.id)
            : this.selected.map(item => item.id);
          this.$httpSecured
          .post("/api/v1/warehouse/dispatch/delete_orrd_items",
            {
              "ids":ids,
              "tab_status": this.tab_name
            }
          )
          .then(response => {
            if (response.data) {
              this.ORRD_delete_confirmation = false;
              this.rejectsussesspopup = true;
              this.successmessage = response.data.message;
            } else {
              this.showAlert("error", "No Data Found");
            }
          }).catch(error => {
                this.showAlert("error", error.response.data.error);
            });
        },
    }
  }
</script>
<style scoped >
  .v-dialog:has(.filter-dispatch) {
    justify-content: right;
    align-items: baseline;
    top: var(--dialog-ypos);
  }

  .v-dialog>.v-card>:has(.v-card__title) {
    overflow-wrap: break-word !important;
  }

  .custom-control_outlined .v-expansion-panel:before {
    box-shadow: none;
  }

  .custom-control_outlined button {
    min-height: 52px;
    border-width: 1px;
    border-color: rgba(0, 0, 0, .42);
    border-style: solid;
  }

  .custom-control_outlined button:focus {
    outline: none;
  }

  .select-all-link {
    color: #1561B1;
    margin-top: -17px;
    margin-left: 233px;
  }

  .margin-right {
    margin-right: 0;
  }

  .field-wrapper {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .text_color {
    color: #83a2ff;
    text-decoration: underline;
  }

  .selected_rule_box {
    display: flex;
    flex-wrap: wrap;
  }

  .rule-type_option {
    border: 1px solid #000000;
    padding: 4px 8px;
    border-radius: 5px;
    margin: 1px 2px;
  }
  .item-selected {
    margin-top: 3px;
    position: absolute;
    left: 41%;
  }

  @media (max-height: 1104px) {
    .PaddingItemPerPage {
      padding: 8px !important;
    }
  }

  @media (min-height: 1126px) {
    .PaddingItemPerPage {
      padding: 24px !important;
    }
  }
  .custom-pagination-ui > .v-input__control > .v-input__slot > .v-select__slot > .v-select__selections > .v-select__selection {
    margin: 0px 0px 18px !important;
  }
  .custom-pagination-ui > .v-input__control > .v-input__slot > fieldset {
    height: 40px;
  }
  .custom-pagination-ui > .v-input__control > .v-input__slot {
    padding: 0px 4px !important;
    min-height: 40px;
    min-width: 67px;
  }
  .custom-pagination-ui > .v-input__control > .v-input__slot > .v-select__slot > .v-input__append-inner {
    margin-top: 6px;
  }
  .custom-column-ui > .custom-pagination-ui > .v-pagination {
    position: absolute;
    right: 30px;
    justify-content: end;
  }
  .custom-pagination-ui > .v-pagination > li > .v-pagination__navigation,
  .custom-pagination-ui > .v-pagination > li > .v-pagination__item--active, 
  .custom-pagination-ui > .v-pagination > li > .v-pagination__item, 
  .custom-pagination-ui > .v-pagination > li > .v-pagination__item--active
  {
    box-shadow: none !important;
    color: rgba(0, 0, 0, .87) !important;
  }
  .custom-pagination-ui > .v-pagination > li > .v-pagination__item, .custom-pagination-ui > .v-pagination > li > .primary {
    background-color: transparent !important;
    border-color: transparent !important;
  }
  .theme--light.v-btn.submit-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: #1976d2 !important;
    color: white !important;
    border-color: #1976d2 !important;
    pointer-events: none;
    opacity: 0.6;
  }
  .v-data-table {
    height: calc(var(--vh, 1vh) * 100 - 323px) !important;
  }
  .v-autocomplete__content.v-menu__content .v-select-list {
    max-width: 285px !important;
  }
  .filter_ui{
    margin-left: 15px !important;
    margin-top: 24px !important;
  }
  .dynamic-height {
    height: calc(var(--vh, 1vh) * 100 - 150px) !important;
  }
</style>
